import { isProxy as No, toRaw as _e, track as vt, pauseTracking as ke, resetTracking as Se, isRef as Be, watch as Tr, computed as $r, isReactive as On, isShallow as Pt, isReadonly as _o, shallowReadonly as $e, shallowRef as Fr, readonly as Ar, proxyRefs as Vn, markRaw as Ir, traverse as Pr, shallowReadArray as kr, toReadonly as Sr, toReactive as zo, ReactiveEffect as Mr, EffectScope as jr, reactive as Rr, shallowReactive as Hr, trigger as Dn } from "../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { effectScope as Zi, getCurrentScope as zi, onWatcherCleanup as el, ref as tl, toRef as ol, unref as nl } from "../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { getGlobalThis as Dt, isFunction as A, extend as ee, isString as ue, normalizeClass as xn, isObject as X, isArray as I, normalizeStyle as wn, isOn as Zt, NOOP as ne, EMPTY_OBJ as H, isPromise as ko, toHandlerKey as Je, hasOwn as R, remove as Cn, camelize as me, capitalize as Ut, isSymbol as Lr, EMPTY_ARR as nt, isBuiltInDirective as Ur, isReservedProp as Et, def as Bt, invokeArrayFns as dt, makeMap as Tn, NO as Br, hyphenate as lt, toRawType as Kr, looseToNumber as Wr, isModelListener as vo } from "../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import { toDisplayString as sl } from "../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
/**
* @vue/runtime-core v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Ye = [];
function kt(e) {
  Ye.push(e);
}
function St() {
  Ye.pop();
}
let fo = !1;
function N(e, ...t) {
  if (fo)
    return;
  fo = !0, ke();
  const o = Ye.length ? Ye[Ye.length - 1].component : null, n = o && o.appContext.config.warnHandler, s = qr();
  if (n)
    ct(
      n,
      o,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((r) => {
          var l, c;
          return (c = (l = r.toString) == null ? void 0 : l.call(r)) != null ? c : JSON.stringify(r);
        }).join(""),
        o && o.proxy,
        s.map(
          ({ vnode: r }) => `at <${ro(o, r.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const r = [`[Vue warn]: ${e}`, ...t];
    s.length && r.push(`
`, ...Jr(s)), console.warn(...r);
  }
  Se(), fo = !1;
}
function qr() {
  let e = Ye[Ye.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const o = t[0];
    o && o.vnode === e ? o.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const n = e.component && e.component.parent;
    e = n && n.vnode;
  }
  return t;
}
function Jr(e) {
  const t = [];
  return e.forEach((o, n) => {
    t.push(...n === 0 ? [] : [`
`], ...Gr(o));
  }), t;
}
function Gr({ vnode: e, recurseCount: t }) {
  const o = t > 0 ? `... (${t} recursive calls)` : "", n = e.component ? e.component.parent == null : !1, s = ` at <${ro(
    e.component,
    e.type,
    n
  )}`, r = ">" + o;
  return e.props ? [s, ...Yr(e.props), r] : [s + r];
}
function Yr(e) {
  const t = [], o = Object.keys(e);
  return o.slice(0, 3).forEach((n) => {
    t.push(...$n(n, e[n]));
  }), o.length > 3 && t.push(" ..."), t;
}
function $n(e, t, o) {
  return ue(t) ? (t = JSON.stringify(t), o ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? o ? t : [`${e}=${t}`] : Be(t) ? (t = $n(e, _e(t.value), !0), o ? t : [`${e}=Ref<`, t, ">"]) : A(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = _e(t), o ? t : [`${e}=`, t]);
}
function Ai(e, t) {
  process.env.NODE_ENV !== "production" && e !== void 0 && (typeof e != "number" ? N(`${t} is not a valid number - got ${JSON.stringify(e)}.`) : isNaN(e) && N(`${t} is NaN - the duration expression might be incorrect.`));
}
const So = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function ct(e, t, o, n) {
  try {
    return n ? e(...n) : e();
  } catch (s) {
    xt(s, t, o);
  }
}
function Fe(e, t, o, n) {
  if (A(e)) {
    const s = ct(e, t, o, n);
    return s && ko(s) && s.catch((r) => {
      xt(r, t, o);
    }), s;
  }
  if (I(e)) {
    const s = [];
    for (let r = 0; r < e.length; r++)
      s.push(Fe(e[r], t, o, n));
    return s;
  } else
    process.env.NODE_ENV !== "production" && N(
      `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
    );
}
function xt(e, t, o, n = !0) {
  const s = t ? t.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: l } = t && t.appContext.config || H;
  if (t) {
    let c = t.parent;
    const a = t.proxy, p = process.env.NODE_ENV !== "production" ? So[o] : `https://vuejs.org/error-reference/#runtime-${o}`;
    for (; c; ) {
      const f = c.ec;
      if (f) {
        for (let d = 0; d < f.length; d++)
          if (f[d](e, a, p) === !1)
            return;
      }
      c = c.parent;
    }
    if (r) {
      ke(), ct(r, null, 10, [
        e,
        a,
        p
      ]), Se();
      return;
    }
  }
  Qr(e, o, s, n, l);
}
function Qr(e, t, o, n = !0, s = !1) {
  if (process.env.NODE_ENV !== "production") {
    const r = So[t];
    if (o && kt(o), N(`Unhandled error${r ? ` during execution of ${r}` : ""}`), o && St(), n)
      throw e;
    console.error(e);
  } else {
    if (s)
      throw e;
    console.error(e);
  }
}
const ce = [];
let Te = -1;
const rt = [];
let Re = null, ot = 0;
const Fn = /* @__PURE__ */ Promise.resolve();
let Kt = null;
const Xr = 100;
function Zr(e) {
  const t = Kt || Fn;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function zr(e) {
  let t = Te + 1, o = ce.length;
  for (; t < o; ) {
    const n = t + o >>> 1, s = ce[n], r = yt(s);
    r < e || r === e && s.flags & 2 ? t = n + 1 : o = n;
  }
  return t;
}
function zt(e) {
  if (!(e.flags & 1)) {
    const t = yt(e), o = ce[ce.length - 1];
    !o || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= yt(o) ? ce.push(e) : ce.splice(zr(t), 0, e), e.flags |= 1, An();
  }
}
function An() {
  Kt || (Kt = Fn.then(kn));
}
function In(e) {
  I(e) ? rt.push(...e) : Re && e.id === -1 ? Re.splice(ot + 1, 0, e) : e.flags & 1 || (rt.push(e), e.flags |= 1), An();
}
function en(e, t, o = Te + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); o < ce.length; o++) {
    const n = ce[o];
    if (n && n.flags & 2) {
      if (e && n.id !== e.uid || process.env.NODE_ENV !== "production" && Mo(t, n))
        continue;
      ce.splice(o, 1), o--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function Pn(e) {
  if (rt.length) {
    const t = [...new Set(rt)].sort(
      (o, n) => yt(o) - yt(n)
    );
    if (rt.length = 0, Re) {
      Re.push(...t);
      return;
    }
    for (Re = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), ot = 0; ot < Re.length; ot++) {
      const o = Re[ot];
      process.env.NODE_ENV !== "production" && Mo(e, o) || (o.flags & 4 && (o.flags &= -2), o.flags & 8 || o(), o.flags &= -2);
    }
    Re = null, ot = 0;
  }
}
const yt = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function kn(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (o) => Mo(e, o) : ne;
  try {
    for (Te = 0; Te < ce.length; Te++) {
      const o = ce[Te];
      if (o && !(o.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(o))
          continue;
        o.flags & 4 && (o.flags &= -2), ct(
          o,
          o.i,
          o.i ? 15 : 14
        ), o.flags & 4 || (o.flags &= -2);
      }
    }
  } finally {
    for (; Te < ce.length; Te++) {
      const o = ce[Te];
      o && (o.flags &= -2);
    }
    Te = -1, ce.length = 0, Pn(e), Kt = null, (ce.length || rt.length) && kn(e);
  }
}
function Mo(e, t) {
  const o = e.get(t) || 0;
  if (o > Xr) {
    const n = t.i, s = n && Go(n.type);
    return xt(
      `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, o + 1), !1;
}
let Oe = !1;
const Mt = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (Dt().__VUE_HMR_RUNTIME__ = {
  createRecord: ao(Sn),
  rerender: ao(os),
  reload: ao(ns)
});
const Ze = /* @__PURE__ */ new Map();
function es(e) {
  const t = e.type.__hmrId;
  let o = Ze.get(t);
  o || (Sn(t, e.type), o = Ze.get(t)), o.instances.add(e);
}
function ts(e) {
  Ze.get(e.type.__hmrId).instances.delete(e);
}
function Sn(e, t) {
  return Ze.has(e) ? !1 : (Ze.set(e, {
    initialDef: Wt(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Wt(e) {
  return xr(e) ? e.__vccOpts : e;
}
function os(e, t) {
  const o = Ze.get(e);
  o && (o.initialDef.render = t, [...o.instances].forEach((n) => {
    t && (n.render = t, Wt(n.type).render = t), n.renderCache = [], Oe = !0, n.update(), Oe = !1;
  }));
}
function ns(e, t) {
  const o = Ze.get(e);
  if (!o)
    return;
  t = Wt(t), tn(o.initialDef, t);
  const n = [...o.instances];
  for (let s = 0; s < n.length; s++) {
    const r = n[s], l = Wt(r.type);
    let c = Mt.get(l);
    c || (l !== o.initialDef && tn(l, t), Mt.set(l, c = /* @__PURE__ */ new Set())), c.add(r), r.appContext.propsCache.delete(r.type), r.appContext.emitsCache.delete(r.type), r.appContext.optionsCache.delete(r.type), r.ceReload ? (c.add(r), r.ceReload(t.styles), c.delete(r)) : r.parent ? zt(() => {
      Oe = !0, r.parent.update(), Oe = !1, c.delete(r);
    }) : r.appContext.reload ? r.appContext.reload() : typeof window != "undefined" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), r.root.ce && r !== r.root && r.root.ce._removeChildStyle(l);
  }
  In(() => {
    Mt.clear();
  });
}
function tn(e, t) {
  ee(e, t);
  for (const o in e)
    o !== "__file" && !(o in t) && delete e[o];
}
function ao(e) {
  return (t, o) => {
    try {
      return e(t, o);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let be, ht = [], yo = !1;
function wt(e, ...t) {
  be ? be.emit(e, ...t) : yo || ht.push({ event: e, args: t });
}
function jo(e, t) {
  var o, n;
  be = e, be ? (be.enabled = !0, ht.forEach(({ event: s, args: r }) => be.emit(s, ...r)), ht = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window != "undefined" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((n = (o = window.navigator) == null ? void 0 : o.userAgent) != null && n.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((r) => {
    jo(r, t);
  }), setTimeout(() => {
    be || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, yo = !0, ht = []);
  }, 3e3)) : (yo = !0, ht = []);
}
function rs(e, t) {
  wt("app:init", e, t, {
    Fragment: de,
    Text: Tt,
    Comment: G,
    Static: Ht
  });
}
function ss(e) {
  wt("app:unmount", e);
}
const is = /* @__PURE__ */ Ro(
  "component:added"
  /* COMPONENT_ADDED */
), Mn = /* @__PURE__ */ Ro(
  "component:updated"
  /* COMPONENT_UPDATED */
), ls = /* @__PURE__ */ Ro(
  "component:removed"
  /* COMPONENT_REMOVED */
), cs = (e) => {
  be && typeof be.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !be.cleanupBuffer(e) && ls(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Ro(e) {
  return (t) => {
    wt(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const us = /* @__PURE__ */ jn(
  "perf:start"
  /* PERFORMANCE_START */
), fs = /* @__PURE__ */ jn(
  "perf:end"
  /* PERFORMANCE_END */
);
function jn(e) {
  return (t, o, n) => {
    wt(e, t.appContext.app, t.uid, t, o, n);
  };
}
function as(e, t, o) {
  wt(
    "component:emit",
    e.appContext.app,
    e,
    t,
    o
  );
}
let Y = null, Rn = null;
function qt(e) {
  const t = Y;
  return Y = e, Rn = e && e.type.__scopeId || null, t;
}
function ds(e, t = Y, o) {
  if (!t || e._n)
    return e;
  const n = (...s) => {
    n._d && Nn(-1);
    const r = qt(t);
    let l;
    try {
      l = e(...s);
    } finally {
      qt(r), n._d && Nn(1);
    }
    return process.env.NODE_ENV !== "production" && Mn(t), l;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function Hn(e) {
  Ur(e) && N("Do not use built-in directive ids as custom directive id: " + e);
}
function Ii(e, t) {
  if (Y === null)
    return process.env.NODE_ENV !== "production" && N("withDirectives can only be used inside render functions."), e;
  const o = no(Y), n = e.dirs || (e.dirs = []);
  for (let s = 0; s < t.length; s++) {
    let [r, l, c, a = H] = t[s];
    r && (A(r) && (r = {
      mounted: r,
      updated: r
    }), r.deep && Pr(l), n.push({
      dir: r,
      instance: o,
      value: l,
      oldValue: void 0,
      arg: c,
      modifiers: a
    }));
  }
  return e;
}
function We(e, t, o, n) {
  const s = e.dirs, r = t && t.dirs;
  for (let l = 0; l < s.length; l++) {
    const c = s[l];
    r && (c.oldValue = r[l].value);
    let a = c.dir[n];
    a && (ke(), Fe(a, o, 8, [
      e.el,
      c,
      e,
      t
    ]), Se());
  }
}
const Ln = Symbol("_vte"), Un = (e) => e.__isTeleport, Qe = (e) => e && (e.disabled || e.disabled === ""), on = (e) => e && (e.defer || e.defer === ""), nn = (e) => typeof SVGElement != "undefined" && e instanceof SVGElement, rn = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, bo = (e, t) => {
  const o = e && e.to;
  if (ue(o))
    if (t) {
      const n = t(o);
      return process.env.NODE_ENV !== "production" && !n && !Qe(e) && N(
        `Failed to locate Teleport target with selector "${o}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
      ), n;
    } else
      return process.env.NODE_ENV !== "production" && N(
        "Current renderer does not support string target for Teleports. (missing querySelector renderer option)"
      ), null;
  else
    return process.env.NODE_ENV !== "production" && !o && !Qe(e) && N(`Invalid Teleport target: ${o}`), o;
}, Bn = {
  name: "Teleport",
  __isTeleport: !0,
  process(e, t, o, n, s, r, l, c, a, p) {
    const {
      mc: f,
      pc: d,
      pbc: E,
      o: { insert: b, querySelector: x, createText: T, createComment: te }
    } = p, j = Qe(t.props);
    let { shapeFlag: Z, children: W, dynamicChildren: he } = t;
    if (process.env.NODE_ENV !== "production" && Oe && (a = !1, he = null), e == null) {
      const U = t.el = process.env.NODE_ENV !== "production" ? te("teleport start") : T(""), q = t.anchor = process.env.NODE_ENV !== "production" ? te("teleport end") : T("");
      b(U, o, n), b(q, o, n);
      const oe = (C, M) => {
        Z & 16 && (s && s.isCE && (s.ce._teleportTarget = C), f(
          W,
          C,
          M,
          s,
          r,
          l,
          c,
          a
        ));
      }, J = () => {
        const C = t.target = bo(t.props, x), M = Kn(C, t, T, b);
        C ? (l !== "svg" && nn(C) ? l = "svg" : l !== "mathml" && rn(C) && (l = "mathml"), j || (oe(C, M), jt(t, !1))) : process.env.NODE_ENV !== "production" && !j && N(
          "Invalid Teleport target on mount:",
          C,
          `(${typeof C})`
        );
      };
      j && (oe(o, q), jt(t, !0)), on(t.props) ? (t.el.__isMounted = !1, le(() => {
        J(), delete t.el.__isMounted;
      }, r)) : J();
    } else {
      if (on(t.props) && e.el.__isMounted === !1) {
        le(() => {
          Bn.process(
            e,
            t,
            o,
            n,
            s,
            r,
            l,
            c,
            a,
            p
          );
        }, r);
        return;
      }
      t.el = e.el, t.targetStart = e.targetStart;
      const U = t.anchor = e.anchor, q = t.target = e.target, oe = t.targetAnchor = e.targetAnchor, J = Qe(e.props), C = J ? o : q, M = J ? U : oe;
      if (l === "svg" || nn(q) ? l = "svg" : (l === "mathml" || rn(q)) && (l = "mathml"), he ? (E(
        e.dynamicChildren,
        he,
        C,
        s,
        r,
        l,
        c
      ), Nt(e, t, process.env.NODE_ENV === "production")) : a || d(
        e,
        t,
        C,
        M,
        s,
        r,
        l,
        c,
        !1
      ), j)
        J ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : At(
          t,
          o,
          U,
          p,
          1
        );
      else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
        const K = t.target = bo(
          t.props,
          x
        );
        K ? At(
          t,
          K,
          null,
          p,
          0
        ) : process.env.NODE_ENV !== "production" && N(
          "Invalid Teleport target on update:",
          q,
          `(${typeof q})`
        );
      } else
        J && At(
          t,
          q,
          oe,
          p,
          1
        );
      jt(t, j);
    }
  },
  remove(e, t, o, { um: n, o: { remove: s } }, r) {
    const {
      shapeFlag: l,
      children: c,
      anchor: a,
      targetStart: p,
      targetAnchor: f,
      target: d,
      props: E
    } = e;
    if (d && (s(p), s(f)), r && s(a), l & 16) {
      const b = r || !Qe(E);
      for (let x = 0; x < c.length; x++) {
        const T = c[x];
        n(
          T,
          t,
          o,
          b,
          !!T.dynamicChildren
        );
      }
    }
  },
  move: At,
  hydrate: ps
};
function At(e, t, o, { o: { insert: n }, m: s }, r = 2) {
  r === 0 && n(e.targetAnchor, t, o);
  const { el: l, anchor: c, shapeFlag: a, children: p, props: f } = e, d = r === 2;
  if (d && n(l, t, o), (!d || Qe(f)) && a & 16)
    for (let E = 0; E < p.length; E++)
      s(
        p[E],
        t,
        o,
        2
      );
  d && n(c, t, o);
}
function ps(e, t, o, n, s, r, {
  o: { nextSibling: l, parentNode: c, querySelector: a, insert: p, createText: f }
}, d) {
  const E = t.target = bo(
    t.props,
    a
  );
  if (E) {
    const b = Qe(t.props), x = E._lpa || E.firstChild;
    if (t.shapeFlag & 16)
      if (b)
        t.anchor = d(
          l(e),
          t,
          c(e),
          o,
          n,
          s,
          r
        ), t.targetStart = x, t.targetAnchor = x && l(x);
      else {
        t.anchor = l(e);
        let T = x;
        for (; T; ) {
          if (T && T.nodeType === 8) {
            if (T.data === "teleport start anchor")
              t.targetStart = T;
            else if (T.data === "teleport anchor") {
              t.targetAnchor = T, E._lpa = t.targetAnchor && l(t.targetAnchor);
              break;
            }
          }
          T = l(T);
        }
        t.targetAnchor || Kn(E, t, f, p), d(
          x && l(x),
          t,
          E,
          o,
          n,
          s,
          r
        );
      }
    jt(t, b);
  }
  return t.anchor && l(t.anchor);
}
const Pi = Bn;
function jt(e, t) {
  const o = e.ctx;
  if (o && o.ut) {
    let n, s;
    for (t ? (n = e.el, s = e.anchor) : (n = e.targetStart, s = e.targetAnchor); n && n !== s; )
      n.nodeType === 1 && n.setAttribute("data-v-owner", o.uid), n = n.nextSibling;
    o.ut();
  }
}
function Kn(e, t, o, n) {
  const s = t.targetStart = o(""), r = t.targetAnchor = o("");
  return s[Ln] = r, e && (n(s, e), n(r, e)), r;
}
const He = Symbol("_leaveCb"), It = Symbol("_enterCb");
function hs() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return Zn(() => {
    e.isMounted = !0;
  }), zn(() => {
    e.isUnmounting = !0;
  }), e;
}
const Ne = [Function, Array], gs = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Ne,
  onEnter: Ne,
  onAfterEnter: Ne,
  onEnterCancelled: Ne,
  // leave
  onBeforeLeave: Ne,
  onLeave: Ne,
  onAfterLeave: Ne,
  onLeaveCancelled: Ne,
  // appear
  onBeforeAppear: Ne,
  onAppear: Ne,
  onAfterAppear: Ne,
  onAppearCancelled: Ne
}, Wn = (e) => {
  const t = e.subTree;
  return t.component ? Wn(t.component) : t;
}, Es = {
  name: "BaseTransition",
  props: gs,
  setup(e, { slots: t }) {
    const o = oo(), n = hs();
    return () => {
      const s = t.default && Gn(t.default(), !0);
      if (!s || !s.length)
        return;
      const r = qn(s), l = _e(e), { mode: c } = l;
      if (process.env.NODE_ENV !== "production" && c && c !== "in-out" && c !== "out-in" && c !== "default" && N(`invalid <transition> mode: ${c}`), n.isLeaving)
        return po(r);
      const a = sn(r);
      if (!a)
        return po(r);
      let p = Oo(
        a,
        l,
        n,
        o,
        // #11061, ensure enterHooks is fresh after clone
        (d) => p = d
      );
      a.type !== G && bt(a, p);
      let f = o.subTree && sn(o.subTree);
      if (f && f.type !== G && !Ge(a, f) && Wn(o).type !== G) {
        let d = Oo(
          f,
          l,
          n,
          o
        );
        if (bt(f, d), c === "out-in" && a.type !== G)
          return n.isLeaving = !0, d.afterLeave = () => {
            n.isLeaving = !1, o.job.flags & 8 || o.update(), delete d.afterLeave, f = void 0;
          }, po(r);
        c === "in-out" && a.type !== G ? d.delayLeave = (E, b, x) => {
          const T = Jn(
            n,
            f
          );
          T[String(f.key)] = f, E[He] = () => {
            b(), E[He] = void 0, delete p.delayedLeave, f = void 0;
          }, p.delayedLeave = () => {
            x(), delete p.delayedLeave, f = void 0;
          };
        } : f = void 0;
      } else
        f && (f = void 0);
      return r;
    };
  }
};
function qn(e) {
  let t = e[0];
  if (e.length > 1) {
    let o = !1;
    for (const n of e)
      if (n.type !== G) {
        if (process.env.NODE_ENV !== "production" && o) {
          N(
            "<transition> can only be used on a single element or component. Use <transition-group> for lists."
          );
          break;
        }
        if (t = n, o = !0, process.env.NODE_ENV === "production")
          break;
      }
  }
  return t;
}
const ki = Es;
function Jn(e, t) {
  const { leavingVNodes: o } = e;
  let n = o.get(t.type);
  return n || (n = /* @__PURE__ */ Object.create(null), o.set(t.type, n)), n;
}
function Oo(e, t, o, n, s) {
  const {
    appear: r,
    mode: l,
    persisted: c = !1,
    onBeforeEnter: a,
    onEnter: p,
    onAfterEnter: f,
    onEnterCancelled: d,
    onBeforeLeave: E,
    onLeave: b,
    onAfterLeave: x,
    onLeaveCancelled: T,
    onBeforeAppear: te,
    onAppear: j,
    onAfterAppear: Z,
    onAppearCancelled: W
  } = t, he = String(e.key), U = Jn(o, e), q = (C, M) => {
    C && Fe(
      C,
      n,
      9,
      M
    );
  }, oe = (C, M) => {
    const K = M[1];
    q(C, M), I(C) ? C.every((Q) => Q.length <= 1) && K() : C.length <= 1 && K();
  }, J = {
    mode: l,
    persisted: c,
    beforeEnter(C) {
      let M = a;
      if (!o.isMounted)
        if (r)
          M = te || a;
        else
          return;
      C[He] && C[He](
        !0
        /* cancelled */
      );
      const K = U[he];
      K && Ge(e, K) && K.el[He] && K.el[He](), q(M, [C]);
    },
    enter(C) {
      let M = p, K = f, Q = d;
      if (!o.isMounted)
        if (r)
          M = j || p, K = Z || f, Q = W || d;
        else
          return;
      let Ve = !1;
      const Ke = C[It] = (De) => {
        Ve || (Ve = !0, De ? q(Q, [C]) : q(K, [C]), J.delayedLeave && J.delayedLeave(), C[It] = void 0);
      };
      M ? oe(M, [C, Ke]) : Ke();
    },
    leave(C, M) {
      const K = String(e.key);
      if (C[It] && C[It](
        !0
        /* cancelled */
      ), o.isUnmounting)
        return M();
      q(E, [C]);
      let Q = !1;
      const Ve = C[He] = (Ke) => {
        Q || (Q = !0, M(), Ke ? q(T, [C]) : q(x, [C]), C[He] = void 0, U[K] === e && delete U[K]);
      };
      U[K] = e, b ? oe(b, [C, Ve]) : Ve();
    },
    clone(C) {
      const M = Oo(
        C,
        t,
        o,
        n,
        s
      );
      return s && s(M), M;
    }
  };
  return J;
}
function po(e) {
  if (Ct(e))
    return e = Ae(e), e.children = null, e;
}
function sn(e) {
  if (!Ct(e))
    return Un(e.type) && e.children ? qn(e.children) : e;
  if (e.component)
    return e.component.subTree;
  const { shapeFlag: t, children: o } = e;
  if (o) {
    if (t & 16)
      return o[0];
    if (t & 32 && A(o.default))
      return o.default();
  }
}
function bt(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, bt(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function Gn(e, t = !1, o) {
  let n = [], s = 0;
  for (let r = 0; r < e.length; r++) {
    let l = e[r];
    const c = o == null ? l.key : String(o) + String(l.key != null ? l.key : r);
    l.type === de ? (l.patchFlag & 128 && s++, n = n.concat(
      Gn(l.children, t, c)
    )) : (t || l.type !== G) && n.push(c != null ? Ae(l, { key: c }) : l);
  }
  if (s > 1)
    for (let r = 0; r < n.length; r++)
      n[r].patchFlag = -2;
  return n;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Si(e, t) {
  return A(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => ee({ name: e.name }, t, { setup: e }))()
  ) : e;
}
function Yn(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const Qn = /* @__PURE__ */ new WeakSet();
function Mi(e) {
  const t = oo(), o = Fr(null);
  if (t) {
    const s = t.refs === H ? t.refs = {} : t.refs;
    let r;
    process.env.NODE_ENV !== "production" && (r = Object.getOwnPropertyDescriptor(s, e)) && !r.configurable ? N(`useTemplateRef('${e}') already exists.`) : Object.defineProperty(s, e, {
      enumerable: !0,
      get: () => o.value,
      set: (l) => o.value = l
    });
  } else
    process.env.NODE_ENV !== "production" && N(
      "useTemplateRef() is called when there is no active component instance to be associated with."
    );
  const n = process.env.NODE_ENV !== "production" ? Ar(o) : o;
  return process.env.NODE_ENV !== "production" && Qn.add(n), n;
}
function mt(e, t, o, n, s = !1) {
  if (I(e)) {
    e.forEach(
      (x, T) => mt(
        x,
        t && (I(t) ? t[T] : t),
        o,
        n,
        s
      )
    );
    return;
  }
  if (st(n) && !s) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && mt(e, t, o, n.component.subTree);
    return;
  }
  const r = n.shapeFlag & 4 ? no(n.component) : n.el, l = s ? null : r, { i: c, r: a } = e;
  if (process.env.NODE_ENV !== "production" && !c) {
    N(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const p = t && t.r, f = c.refs === H ? c.refs = {} : c.refs, d = c.setupState, E = _e(d), b = d === H ? () => !1 : (x) => process.env.NODE_ENV !== "production" && (R(E, x) && !Be(E[x]) && N(
    `Template ref "${x}" used on a non-ref value. It will not work in the production build.`
  ), Qn.has(E[x])) ? !1 : R(E, x);
  if (p != null && p !== a && (ue(p) ? (f[p] = null, b(p) && (d[p] = null)) : Be(p) && (p.value = null)), A(a))
    ct(a, c, 12, [l, f]);
  else {
    const x = ue(a), T = Be(a);
    if (x || T) {
      const te = () => {
        if (e.f) {
          const j = x ? b(a) ? d[a] : f[a] : a.value;
          s ? I(j) && Cn(j, r) : I(j) ? j.includes(r) || j.push(r) : x ? (f[a] = [r], b(a) && (d[a] = f[a])) : (a.value = [r], e.k && (f[e.k] = a.value));
        } else
          x ? (f[a] = l, b(a) && (d[a] = l)) : T ? (a.value = l, e.k && (f[e.k] = l)) : process.env.NODE_ENV !== "production" && N("Invalid template ref type:", a, `(${typeof a})`);
      };
      l ? (te.id = -1, le(te, o)) : te();
    } else
      process.env.NODE_ENV !== "production" && N("Invalid template ref type:", a, `(${typeof a})`);
  }
}
Dt().requestIdleCallback;
Dt().cancelIdleCallback;
const st = (e) => !!e.type.__asyncLoader, Ct = (e) => e.type.__isKeepAlive;
function ms(e, t) {
  Xn(e, "a", t);
}
function Ns(e, t) {
  Xn(e, "da", t);
}
function Xn(e, t, o = z) {
  const n = e.__wdc || (e.__wdc = () => {
    let s = o;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return e();
  });
  if (eo(t, n, o), o) {
    let s = o.parent;
    for (; s && s.parent; )
      Ct(s.parent.vnode) && _s(n, t, o, s), s = s.parent;
  }
}
function _s(e, t, o, n) {
  const s = eo(
    t,
    e,
    n,
    !0
    /* prepend */
  );
  er(() => {
    Cn(n[t], s);
  }, o);
}
function eo(e, t, o = z, n = !1) {
  if (o) {
    const s = o[e] || (o[e] = []), r = t.__weh || (t.__weh = (...l) => {
      ke();
      const c = $t(o), a = Fe(t, o, e, l);
      return c(), Se(), a;
    });
    return n ? s.unshift(r) : s.push(r), r;
  } else if (process.env.NODE_ENV !== "production") {
    const s = Je(So[e].replace(/ hook$/, ""));
    N(
      `${s} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const Me = (e) => (t, o = z) => {
  (!Vt || e === "sp") && eo(e, (...n) => t(...n), o);
}, vs = Me("bm"), Zn = Me("m"), ys = Me(
  "bu"
), bs = Me("u"), zn = Me(
  "bum"
), er = Me("um"), Os = Me(
  "sp"
), Vs = Me("rtg"), Ds = Me("rtc");
function xs(e, t = z) {
  eo("ec", e, t);
}
const Jt = "components", ws = "directives";
function ji(e, t) {
  return Ho(Jt, e, !0, t) || e;
}
const tr = Symbol.for("v-ndc");
function Ri(e) {
  return ue(e) ? Ho(Jt, e, !1) || e : e || tr;
}
function Hi(e) {
  return Ho(ws, e);
}
function Ho(e, t, o = !0, n = !1) {
  const s = Y || z;
  if (s) {
    const r = s.type;
    if (e === Jt) {
      const c = Go(
        r,
        !1
      );
      if (c && (c === t || c === me(t) || c === Ut(me(t))))
        return r;
    }
    const l = (
      // local registration
      // check instance[type] first which is resolved for options API
      ln(s[e] || r[e], t) || // global registration
      ln(s.appContext[e], t)
    );
    if (!l && n)
      return r;
    if (process.env.NODE_ENV !== "production" && o && !l) {
      const c = e === Jt ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : "";
      N(`Failed to resolve ${e.slice(0, -1)}: ${t}${c}`);
    }
    return l;
  } else
    process.env.NODE_ENV !== "production" && N(
      `resolve${Ut(e.slice(0, -1))} can only be used in render() or setup().`
    );
}
function ln(e, t) {
  return e && (e[t] || e[me(t)] || e[Ut(me(t))]);
}
function Li(e, t, o, n) {
  let s;
  const r = o && o[n], l = I(e);
  if (l || ue(e)) {
    const c = l && On(e);
    let a = !1, p = !1;
    c && (a = !Pt(e), p = _o(e), e = kr(e)), s = new Array(e.length);
    for (let f = 0, d = e.length; f < d; f++)
      s[f] = t(
        a ? p ? Sr(zo(e[f])) : zo(e[f]) : e[f],
        f,
        void 0,
        r && r[f]
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && N(`The v-for range expect an integer value but got ${e}.`), s = new Array(e);
    for (let c = 0; c < e; c++)
      s[c] = t(c + 1, c, void 0, r && r[c]);
  } else if (X(e))
    if (e[Symbol.iterator])
      s = Array.from(
        e,
        (c, a) => t(c, a, void 0, r && r[a])
      );
    else {
      const c = Object.keys(e);
      s = new Array(c.length);
      for (let a = 0, p = c.length; a < p; a++) {
        const f = c[a];
        s[a] = t(e[f], f, a, r && r[a]);
      }
    }
  else
    s = [];
  return o && (o[n] = s), s;
}
function Ui(e, t, o = {}, n, s) {
  if (Y.ce || Y.parent && st(Y.parent) && Y.parent.ce)
    return t !== "default" && (o.name = t), $o(), Fo(
      de,
      null,
      [pe("slot", o, n && n())],
      64
    );
  let r = e[t];
  process.env.NODE_ENV !== "production" && r && r.length > 1 && (N(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), r = () => []), r && r._c && (r._d = !1), $o();
  const l = r && or(r(o)), c = o.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  l && l.key, a = Fo(
    de,
    {
      key: (c && !Lr(c) ? c : `_${t}`) + // #7256 force differentiate fallback content from actual content
      (!l && n ? "_fb" : "")
    },
    l || (n ? n() : []),
    l && e._ === 1 ? 64 : -2
  );
  return !s && a.scopeId && (a.slotScopeIds = [a.scopeId + "-s"]), r && r._c && (r._d = !0), a;
}
function or(e) {
  return e.some((t) => ze(t) ? !(t.type === G || t.type === de && !or(t.children)) : !0) ? e : null;
}
const Vo = (e) => e ? Vr(e) ? no(e) : Vo(e.parent) : null, Xe = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ ee(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? $e(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? $e(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? $e(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? $e(e.refs) : e.refs,
    $parent: (e) => Vo(e.parent),
    $root: (e) => Vo(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => Uo(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      zt(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = Zr.bind(e.proxy)),
    $watch: (e) => si.bind(e)
  })
), Lo = (e) => e === "_" || e === "$", ho = (e, t) => e !== H && !e.__isScriptSetup && R(e, t), nr = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: o, setupState: n, data: s, props: r, accessCache: l, type: c, appContext: a } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let p;
    if (t[0] !== "$") {
      const b = l[t];
      if (b !== void 0)
        switch (b) {
          case 1:
            return n[t];
          case 2:
            return s[t];
          case 4:
            return o[t];
          case 3:
            return r[t];
        }
      else {
        if (ho(n, t))
          return l[t] = 1, n[t];
        if (s !== H && R(s, t))
          return l[t] = 2, s[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (p = e.propsOptions[0]) && R(p, t)
        )
          return l[t] = 3, r[t];
        if (o !== H && R(o, t))
          return l[t] = 4, o[t];
        Do && (l[t] = 0);
      }
    }
    const f = Xe[t];
    let d, E;
    if (f)
      return t === "$attrs" ? (vt(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && Qt()) : process.env.NODE_ENV !== "production" && t === "$slots" && vt(e, "get", t), f(e);
    if (
      // css module (injected by vue-loader)
      (d = c.__cssModules) && (d = d[t])
    )
      return d;
    if (o !== H && R(o, t))
      return l[t] = 4, o[t];
    if (
      // global properties
      E = a.config.globalProperties, R(E, t)
    )
      return E[t];
    process.env.NODE_ENV !== "production" && Y && (!ue(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (s !== H && Lo(t[0]) && R(s, t) ? N(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === Y && N(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, o) {
    const { data: n, setupState: s, ctx: r } = e;
    return ho(s, t) ? (s[t] = o, !0) : process.env.NODE_ENV !== "production" && s.__isScriptSetup && R(s, t) ? (N(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : n !== H && R(n, t) ? (n[t] = o, !0) : R(e.props, t) ? (process.env.NODE_ENV !== "production" && N(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && N(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(r, t, {
      enumerable: !0,
      configurable: !0,
      value: o
    }) : r[t] = o, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: o, ctx: n, appContext: s, propsOptions: r }
  }, l) {
    let c;
    return !!o[l] || e !== H && R(e, l) || ho(t, l) || (c = r[0]) && R(c, l) || R(n, l) || R(Xe, l) || R(s.config.globalProperties, l);
  },
  defineProperty(e, t, o) {
    return o.get != null ? e._.accessCache[t] = 0 : R(o, "value") && this.set(e, t, o.value, null), Reflect.defineProperty(e, t, o);
  }
};
process.env.NODE_ENV !== "production" && (nr.ownKeys = (e) => (N(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function Cs(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Xe).forEach((o) => {
    Object.defineProperty(t, o, {
      configurable: !0,
      enumerable: !1,
      get: () => Xe[o](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: ne
    });
  }), t;
}
function Ts(e) {
  const {
    ctx: t,
    propsOptions: [o]
  } = e;
  o && Object.keys(o).forEach((n) => {
    Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[n],
      set: ne
    });
  });
}
function $s(e) {
  const { ctx: t, setupState: o } = e;
  Object.keys(_e(o)).forEach((n) => {
    if (!o.__isScriptSetup) {
      if (Lo(n[0])) {
        N(
          `setup() return property ${JSON.stringify(
            n
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, n, {
        enumerable: !0,
        configurable: !0,
        get: () => o[n],
        set: ne
      });
    }
  });
}
function cn(e) {
  return I(e) ? e.reduce(
    (t, o) => (t[o] = null, t),
    {}
  ) : e;
}
function Fs() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, o) => {
    e[o] ? N(`${t} property "${o}" is already defined in ${e[o]}.`) : e[o] = t;
  };
}
let Do = !0;
function As(e) {
  const t = Uo(e), o = e.proxy, n = e.ctx;
  Do = !1, t.beforeCreate && un(t.beforeCreate, e, "bc");
  const {
    // state
    data: s,
    computed: r,
    methods: l,
    watch: c,
    provide: a,
    inject: p,
    // lifecycle
    created: f,
    beforeMount: d,
    mounted: E,
    beforeUpdate: b,
    updated: x,
    activated: T,
    deactivated: te,
    beforeDestroy: j,
    beforeUnmount: Z,
    destroyed: W,
    unmounted: he,
    render: U,
    renderTracked: q,
    renderTriggered: oe,
    errorCaptured: J,
    serverPrefetch: C,
    // public API
    expose: M,
    inheritAttrs: K,
    // assets
    components: Q,
    directives: Ve,
    filters: Ke
  } = t, De = process.env.NODE_ENV !== "production" ? Fs() : null;
  if (process.env.NODE_ENV !== "production") {
    const [k] = e.propsOptions;
    if (k)
      for (const P in k)
        De("Props", P);
  }
  if (p && Is(p, n, De), l)
    for (const k in l) {
      const P = l[k];
      A(P) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(n, k, {
        value: P.bind(o),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : n[k] = P.bind(o), process.env.NODE_ENV !== "production" && De("Methods", k)) : process.env.NODE_ENV !== "production" && N(
        `Method "${k}" has type "${typeof P}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (s) {
    process.env.NODE_ENV !== "production" && !A(s) && N(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const k = s.call(o, o);
    if (process.env.NODE_ENV !== "production" && ko(k) && N(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !X(k))
      process.env.NODE_ENV !== "production" && N("data() should return an object.");
    else if (e.data = Rr(k), process.env.NODE_ENV !== "production")
      for (const P in k)
        De("Data", P), Lo(P[0]) || Object.defineProperty(n, P, {
          configurable: !0,
          enumerable: !0,
          get: () => k[P],
          set: ne
        });
  }
  if (Do = !0, r)
    for (const k in r) {
      const P = r[k], xe = A(P) ? P.bind(o, o) : A(P.get) ? P.get.bind(o, o) : ne;
      process.env.NODE_ENV !== "production" && xe === ne && N(`Computed property "${k}" has no getter.`);
      const so = !A(P) && A(P.set) ? P.set.bind(o) : process.env.NODE_ENV !== "production" ? () => {
        N(
          `Write operation failed: computed property "${k}" is readonly.`
        );
      } : ne, ut = Ti({
        get: xe,
        set: so
      });
      Object.defineProperty(n, k, {
        enumerable: !0,
        configurable: !0,
        get: () => ut.value,
        set: (et) => ut.value = et
      }), process.env.NODE_ENV !== "production" && De("Computed", k);
    }
  if (c)
    for (const k in c)
      rr(c[k], n, o, k);
  if (a) {
    const k = A(a) ? a.call(o) : a;
    Reflect.ownKeys(k).forEach((P) => {
      Rs(P, k[P]);
    });
  }
  f && un(f, e, "c");
  function fe(k, P) {
    I(P) ? P.forEach((xe) => k(xe.bind(o))) : P && k(P.bind(o));
  }
  if (fe(vs, d), fe(Zn, E), fe(ys, b), fe(bs, x), fe(ms, T), fe(Ns, te), fe(xs, J), fe(Ds, q), fe(Vs, oe), fe(zn, Z), fe(er, he), fe(Os, C), I(M))
    if (M.length) {
      const k = e.exposed || (e.exposed = {});
      M.forEach((P) => {
        Object.defineProperty(k, P, {
          get: () => o[P],
          set: (xe) => o[P] = xe,
          enumerable: !0
        });
      });
    } else
      e.exposed || (e.exposed = {});
  U && e.render === ne && (e.render = U), K != null && (e.inheritAttrs = K), Q && (e.components = Q), Ve && (e.directives = Ve), C && Yn(e);
}
function Is(e, t, o = ne) {
  I(e) && (e = xo(e));
  for (const n in e) {
    const s = e[n];
    let r;
    X(s) ? "default" in s ? r = Rt(
      s.from || n,
      s.default,
      !0
    ) : r = Rt(s.from || n) : r = Rt(s), Be(r) ? Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => r.value,
      set: (l) => r.value = l
    }) : t[n] = r, process.env.NODE_ENV !== "production" && o("Inject", n);
  }
}
function un(e, t, o) {
  Fe(
    I(e) ? e.map((n) => n.bind(t.proxy)) : e.bind(t.proxy),
    t,
    o
  );
}
function rr(e, t, o, n) {
  let s = n.includes(".") ? gr(o, n) : () => o[n];
  if (ue(e)) {
    const r = t[e];
    A(r) ? Eo(s, r) : process.env.NODE_ENV !== "production" && N(`Invalid watch handler specified by key "${e}"`, r);
  } else if (A(e))
    Eo(s, e.bind(o));
  else if (X(e))
    if (I(e))
      e.forEach((r) => rr(r, t, o, n));
    else {
      const r = A(e.handler) ? e.handler.bind(o) : t[e.handler];
      A(r) ? Eo(s, r, e) : process.env.NODE_ENV !== "production" && N(`Invalid watch handler specified by key "${e.handler}"`, r);
    }
  else
    process.env.NODE_ENV !== "production" && N(`Invalid watch option: "${n}"`, e);
}
function Uo(e) {
  const t = e.type, { mixins: o, extends: n } = t, {
    mixins: s,
    optionsCache: r,
    config: { optionMergeStrategies: l }
  } = e.appContext, c = r.get(t);
  let a;
  return c ? a = c : !s.length && !o && !n ? a = t : (a = {}, s.length && s.forEach(
    (p) => Gt(a, p, l, !0)
  ), Gt(a, t, l)), X(t) && r.set(t, a), a;
}
function Gt(e, t, o, n = !1) {
  const { mixins: s, extends: r } = t;
  r && Gt(e, r, o, !0), s && s.forEach(
    (l) => Gt(e, l, o, !0)
  );
  for (const l in t)
    if (n && l === "expose")
      process.env.NODE_ENV !== "production" && N(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const c = Ps[l] || o && o[l];
      e[l] = c ? c(e[l], t[l]) : t[l];
    }
  return e;
}
const Ps = {
  data: fn,
  props: an,
  emits: an,
  // objects
  methods: gt,
  computed: gt,
  // lifecycle
  beforeCreate: ie,
  created: ie,
  beforeMount: ie,
  mounted: ie,
  beforeUpdate: ie,
  updated: ie,
  beforeDestroy: ie,
  beforeUnmount: ie,
  destroyed: ie,
  unmounted: ie,
  activated: ie,
  deactivated: ie,
  errorCaptured: ie,
  serverPrefetch: ie,
  // assets
  components: gt,
  directives: gt,
  // watch
  watch: Ss,
  // provide / inject
  provide: fn,
  inject: ks
};
function fn(e, t) {
  return t ? e ? function() {
    return ee(
      A(e) ? e.call(this, this) : e,
      A(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function ks(e, t) {
  return gt(xo(e), xo(t));
}
function xo(e) {
  if (I(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++)
      t[e[o]] = e[o];
    return t;
  }
  return e;
}
function ie(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function gt(e, t) {
  return e ? ee(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function an(e, t) {
  return e ? I(e) && I(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : ee(
    /* @__PURE__ */ Object.create(null),
    cn(e),
    cn(t != null ? t : {})
  ) : t;
}
function Ss(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  const o = ee(/* @__PURE__ */ Object.create(null), e);
  for (const n in t)
    o[n] = ie(e[n], t[n]);
  return o;
}
function sr() {
  return {
    app: null,
    config: {
      isNativeTag: Br,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Ms = 0;
function js(e, t) {
  return function(n, s = null) {
    A(n) || (n = ee({}, n)), s != null && !X(s) && (process.env.NODE_ENV !== "production" && N("root props passed to app.mount() must be an object."), s = null);
    const r = sr(), l = /* @__PURE__ */ new WeakSet(), c = [];
    let a = !1;
    const p = r.app = {
      _uid: Ms++,
      _component: n,
      _props: s,
      _container: null,
      _context: r,
      _instance: null,
      version: bn,
      get config() {
        return r.config;
      },
      set config(f) {
        process.env.NODE_ENV !== "production" && N(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(f, ...d) {
        return l.has(f) ? process.env.NODE_ENV !== "production" && N("Plugin has already been applied to target app.") : f && A(f.install) ? (l.add(f), f.install(p, ...d)) : A(f) ? (l.add(f), f(p, ...d)) : process.env.NODE_ENV !== "production" && N(
          'A plugin must either be a function or an object with an "install" function.'
        ), p;
      },
      mixin(f) {
        return r.mixins.includes(f) ? process.env.NODE_ENV !== "production" && N(
          "Mixin has already been applied to target app" + (f.name ? `: ${f.name}` : "")
        ) : r.mixins.push(f), p;
      },
      component(f, d) {
        return process.env.NODE_ENV !== "production" && Io(f, r.config), d ? (process.env.NODE_ENV !== "production" && r.components[f] && N(`Component "${f}" has already been registered in target app.`), r.components[f] = d, p) : r.components[f];
      },
      directive(f, d) {
        return process.env.NODE_ENV !== "production" && Hn(f), d ? (process.env.NODE_ENV !== "production" && r.directives[f] && N(`Directive "${f}" has already been registered in target app.`), r.directives[f] = d, p) : r.directives[f];
      },
      mount(f, d, E) {
        if (a)
          process.env.NODE_ENV !== "production" && N(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && f.__vue_app__ && N(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const b = p._ceVNode || pe(n, s);
          return b.appContext = r, E === !0 ? E = "svg" : E === !1 && (E = void 0), process.env.NODE_ENV !== "production" && (r.reload = () => {
            const x = Ae(b);
            x.el = null, e(x, f, E);
          }), d && t ? t(b, f) : e(b, f, E), a = !0, p._container = f, f.__vue_app__ = p, process.env.NODE_ENV !== "production" && (p._instance = b.component, rs(p, bn)), no(b.component);
        }
      },
      onUnmount(f) {
        process.env.NODE_ENV !== "production" && typeof f != "function" && N(
          `Expected function as first argument to app.onUnmount(), but got ${typeof f}`
        ), c.push(f);
      },
      unmount() {
        a ? (Fe(
          c,
          p._instance,
          16
        ), e(null, p._container), process.env.NODE_ENV !== "production" && (p._instance = null, ss(p)), delete p._container.__vue_app__) : process.env.NODE_ENV !== "production" && N("Cannot unmount an app that is not mounted.");
      },
      provide(f, d) {
        return process.env.NODE_ENV !== "production" && f in r.provides && (R(r.provides, f) ? N(
          `App already provides property with key "${String(f)}". It will be overwritten with the new value.`
        ) : N(
          `App already provides property with key "${String(f)}" inherited from its parent element. It will be overwritten with the new value.`
        )), r.provides[f] = d, p;
      },
      runWithContext(f) {
        const d = it;
        it = p;
        try {
          return f();
        } finally {
          it = d;
        }
      }
    };
    return p;
  };
}
let it = null;
function Rs(e, t) {
  if (!z)
    process.env.NODE_ENV !== "production" && N("provide() can only be used inside setup().");
  else {
    let o = z.provides;
    const n = z.parent && z.parent.provides;
    n === o && (o = z.provides = Object.create(n)), o[e] = t;
  }
}
function Rt(e, t, o = !1) {
  const n = oo();
  if (n || it) {
    let s = it ? it._context.provides : n ? n.parent == null || n.ce ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return o && A(t) ? t.call(n && n.proxy) : t;
    process.env.NODE_ENV !== "production" && N(`injection "${String(e)}" not found.`);
  } else
    process.env.NODE_ENV !== "production" && N("inject() can only be used inside setup() or functional components.");
}
const ir = {}, lr = () => Object.create(ir), cr = (e) => Object.getPrototypeOf(e) === ir;
function Hs(e, t, o, n = !1) {
  const s = {}, r = lr();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), ur(e, t, s, r);
  for (const l in e.propsOptions[0])
    l in s || (s[l] = void 0);
  process.env.NODE_ENV !== "production" && ar(t || {}, s, e), o ? e.props = n ? s : Hr(s) : e.type.props ? e.props = s : e.props = r, e.attrs = r;
}
function Ls(e) {
  for (; e; ) {
    if (e.type.__hmrId)
      return !0;
    e = e.parent;
  }
}
function Us(e, t, o, n) {
  const {
    props: s,
    attrs: r,
    vnode: { patchFlag: l }
  } = e, c = _e(s), [a] = e.propsOptions;
  let p = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && Ls(e)) && (n || l > 0) && !(l & 16)
  ) {
    if (l & 8) {
      const f = e.vnode.dynamicProps;
      for (let d = 0; d < f.length; d++) {
        let E = f[d];
        if (to(e.emitsOptions, E))
          continue;
        const b = t[E];
        if (a)
          if (R(r, E))
            b !== r[E] && (r[E] = b, p = !0);
          else {
            const x = me(E);
            s[x] = wo(
              a,
              c,
              x,
              b,
              e,
              !1
            );
          }
        else
          b !== r[E] && (r[E] = b, p = !0);
      }
    }
  } else {
    ur(e, t, s, r) && (p = !0);
    let f;
    for (const d in c)
      (!t || // for camelCase
      !R(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((f = lt(d)) === d || !R(t, f))) && (a ? o && // for camelCase
      (o[d] !== void 0 || // for kebab-case
      o[f] !== void 0) && (s[d] = wo(
        a,
        c,
        d,
        void 0,
        e,
        !0
      )) : delete s[d]);
    if (r !== c)
      for (const d in r)
        (!t || !R(t, d)) && (delete r[d], p = !0);
  }
  p && Dn(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && ar(t || {}, s, e);
}
function ur(e, t, o, n) {
  const [s, r] = e.propsOptions;
  let l = !1, c;
  if (t)
    for (let a in t) {
      if (Et(a))
        continue;
      const p = t[a];
      let f;
      s && R(s, f = me(a)) ? !r || !r.includes(f) ? o[f] = p : (c || (c = {}))[f] = p : to(e.emitsOptions, a) || (!(a in n) || p !== n[a]) && (n[a] = p, l = !0);
    }
  if (r) {
    const a = _e(o), p = c || H;
    for (let f = 0; f < r.length; f++) {
      const d = r[f];
      o[d] = wo(
        s,
        a,
        d,
        p[d],
        e,
        !R(p, d)
      );
    }
  }
  return l;
}
function wo(e, t, o, n, s, r) {
  const l = e[o];
  if (l != null) {
    const c = R(l, "default");
    if (c && n === void 0) {
      const a = l.default;
      if (l.type !== Function && !l.skipFactory && A(a)) {
        const { propsDefaults: p } = s;
        if (o in p)
          n = p[o];
        else {
          const f = $t(s);
          n = p[o] = a.call(
            null,
            t
          ), f();
        }
      } else
        n = a;
      s.ce && s.ce._setProp(o, n);
    }
    l[
      0
      /* shouldCast */
    ] && (r && !c ? n = !1 : l[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === lt(o)) && (n = !0));
  }
  return n;
}
const Bs = /* @__PURE__ */ new WeakMap();
function fr(e, t, o = !1) {
  const n = o ? Bs : t.propsCache, s = n.get(e);
  if (s)
    return s;
  const r = e.props, l = {}, c = [];
  let a = !1;
  if (!A(e)) {
    const f = (d) => {
      a = !0;
      const [E, b] = fr(d, t, !0);
      ee(l, E), b && c.push(...b);
    };
    !o && t.mixins.length && t.mixins.forEach(f), e.extends && f(e.extends), e.mixins && e.mixins.forEach(f);
  }
  if (!r && !a)
    return X(e) && n.set(e, nt), nt;
  if (I(r))
    for (let f = 0; f < r.length; f++) {
      process.env.NODE_ENV !== "production" && !ue(r[f]) && N("props must be strings when using array syntax.", r[f]);
      const d = me(r[f]);
      dn(d) && (l[d] = H);
    }
  else if (r) {
    process.env.NODE_ENV !== "production" && !X(r) && N("invalid props options", r);
    for (const f in r) {
      const d = me(f);
      if (dn(d)) {
        const E = r[f], b = l[d] = I(E) || A(E) ? { type: E } : ee({}, E), x = b.type;
        let T = !1, te = !0;
        if (I(x))
          for (let j = 0; j < x.length; ++j) {
            const Z = x[j], W = A(Z) && Z.name;
            if (W === "Boolean") {
              T = !0;
              break;
            } else
              W === "String" && (te = !1);
          }
        else
          T = A(x) && x.name === "Boolean";
        b[
          0
          /* shouldCast */
        ] = T, b[
          1
          /* shouldCastTrue */
        ] = te, (T || R(b, "default")) && c.push(d);
      }
    }
  }
  const p = [l, c];
  return X(e) && n.set(e, p), p;
}
function dn(e) {
  return e[0] !== "$" && !Et(e) ? !0 : (process.env.NODE_ENV !== "production" && N(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Ks(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function ar(e, t, o) {
  const n = _e(t), s = o.propsOptions[0], r = Object.keys(e).map((l) => me(l));
  for (const l in s) {
    let c = s[l];
    c != null && Ws(
      l,
      n[l],
      c,
      process.env.NODE_ENV !== "production" ? $e(n) : n,
      !r.includes(l)
    );
  }
}
function Ws(e, t, o, n, s) {
  const { type: r, required: l, validator: c, skipCheck: a } = o;
  if (l && s) {
    N('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !l)) {
    if (r != null && r !== !0 && !a) {
      let p = !1;
      const f = I(r) ? r : [r], d = [];
      for (let E = 0; E < f.length && !p; E++) {
        const { valid: b, expectedType: x } = Js(t, f[E]);
        d.push(x || ""), p = b;
      }
      if (!p) {
        N(Gs(e, t, d));
        return;
      }
    }
    c && !c(t, n) && N('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const qs = /* @__PURE__ */ Tn(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Js(e, t) {
  let o;
  const n = Ks(t);
  if (n === "null")
    o = e === null;
  else if (qs(n)) {
    const s = typeof e;
    o = s === n.toLowerCase(), !o && s === "object" && (o = e instanceof t);
  } else
    n === "Object" ? o = X(e) : n === "Array" ? o = I(e) : o = e instanceof t;
  return {
    valid: o,
    expectedType: n
  };
}
function Gs(e, t, o) {
  if (o.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let n = `Invalid prop: type check failed for prop "${e}". Expected ${o.map(Ut).join(" | ")}`;
  const s = o[0], r = Kr(t), l = pn(t, s), c = pn(t, r);
  return o.length === 1 && hn(s) && !Ys(s, r) && (n += ` with value ${l}`), n += `, got ${r} `, hn(r) && (n += `with value ${c}.`), n;
}
function pn(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function hn(e) {
  return ["string", "number", "boolean"].some((o) => e.toLowerCase() === o);
}
function Ys(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Bo = (e) => e === "_" || e === "__" || e === "_ctx" || e === "$stable", Ko = (e) => I(e) ? e.map(ye) : [ye(e)], Qs = (e, t, o) => {
  if (t._n)
    return t;
  const n = ds((...s) => (process.env.NODE_ENV !== "production" && z && !(o === null && Y) && !(o && o.root !== z.root) && N(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), Ko(t(...s))), o);
  return n._c = !1, n;
}, dr = (e, t, o) => {
  const n = e._ctx;
  for (const s in e) {
    if (Bo(s))
      continue;
    const r = e[s];
    if (A(r))
      t[s] = Qs(s, r, n);
    else if (r != null) {
      process.env.NODE_ENV !== "production" && N(
        `Non-function value encountered for slot "${s}". Prefer function slots for better performance.`
      );
      const l = Ko(r);
      t[s] = () => l;
    }
  }
}, pr = (e, t) => {
  process.env.NODE_ENV !== "production" && !Ct(e.vnode) && N(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const o = Ko(t);
  e.slots.default = () => o;
}, Co = (e, t, o) => {
  for (const n in t)
    (o || !Bo(n)) && (e[n] = t[n]);
}, Xs = (e, t, o) => {
  const n = e.slots = lr();
  if (e.vnode.shapeFlag & 32) {
    const s = t.__;
    s && Bt(n, "__", s, !0);
    const r = t._;
    r ? (Co(n, t, o), o && Bt(n, "_", r, !0)) : dr(t, n);
  } else
    t && pr(e, t);
}, Zs = (e, t, o) => {
  const { vnode: n, slots: s } = e;
  let r = !0, l = H;
  if (n.shapeFlag & 32) {
    const c = t._;
    c ? process.env.NODE_ENV !== "production" && Oe ? (Co(s, t, o), Dn(e, "set", "$slots")) : o && c === 1 ? r = !1 : Co(s, t, o) : (r = !t.$stable, dr(t, s)), l = t;
  } else
    t && (pr(e, t), l = { default: 1 });
  if (r)
    for (const c in s)
      !Bo(c) && l[c] == null && delete s[c];
};
let pt, Ue;
function Ie(e, t) {
  e.appContext.config.performance && Yt() && Ue.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && us(e, t, Yt() ? Ue.now() : Date.now());
}
function Pe(e, t) {
  if (e.appContext.config.performance && Yt()) {
    const o = `vue-${t}-${e.uid}`, n = o + ":end";
    Ue.mark(n), Ue.measure(
      `<${ro(e, e.type)}> ${t}`,
      o,
      n
    ), Ue.clearMarks(o), Ue.clearMarks(n);
  }
  process.env.NODE_ENV !== "production" && fs(e, t, Yt() ? Ue.now() : Date.now());
}
function Yt() {
  return pt !== void 0 || (typeof window != "undefined" && window.performance ? (pt = !0, Ue = window.performance) : pt = !1), pt;
}
function zs() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const le = di;
function Bi(e) {
  return ei(e);
}
function ei(e, t) {
  zs();
  const o = Dt();
  o.__VUE__ = !0, process.env.NODE_ENV !== "production" && jo(o.__VUE_DEVTOOLS_GLOBAL_HOOK__, o);
  const {
    insert: n,
    remove: s,
    patchProp: r,
    createElement: l,
    createText: c,
    createComment: a,
    setText: p,
    setElementText: f,
    parentNode: d,
    nextSibling: E,
    setScopeId: b = ne,
    insertStaticContent: x
  } = e, T = (i, u, h, _ = null, g = null, m = null, V = void 0, O = null, y = process.env.NODE_ENV !== "production" && Oe ? !1 : !!u.dynamicChildren) => {
    if (i === u)
      return;
    i && !Ge(i, u) && (_ = Ft(i), je(i, g, m, !0), i = null), u.patchFlag === -2 && (y = !1, u.dynamicChildren = null);
    const { type: v, ref: $, shapeFlag: D } = u;
    switch (v) {
      case Tt:
        te(i, u, h, _);
        break;
      case G:
        j(i, u, h, _);
        break;
      case Ht:
        i == null ? Z(u, h, _, V) : process.env.NODE_ENV !== "production" && W(i, u, h, V);
        break;
      case de:
        Ve(
          i,
          u,
          h,
          _,
          g,
          m,
          V,
          O,
          y
        );
        break;
      default:
        D & 1 ? q(
          i,
          u,
          h,
          _,
          g,
          m,
          V,
          O,
          y
        ) : D & 6 ? Ke(
          i,
          u,
          h,
          _,
          g,
          m,
          V,
          O,
          y
        ) : D & 64 || D & 128 ? v.process(
          i,
          u,
          h,
          _,
          g,
          m,
          V,
          O,
          y,
          tt
        ) : process.env.NODE_ENV !== "production" && N("Invalid VNode type:", v, `(${typeof v})`);
    }
    $ != null && g ? mt($, i && i.ref, m, u || i, !u) : $ == null && i && i.ref != null && mt(i.ref, null, m, i, !0);
  }, te = (i, u, h, _) => {
    if (i == null)
      n(
        u.el = c(u.children),
        h,
        _
      );
    else {
      const g = u.el = i.el;
      u.children !== i.children && p(g, u.children);
    }
  }, j = (i, u, h, _) => {
    i == null ? n(
      u.el = a(u.children || ""),
      h,
      _
    ) : u.el = i.el;
  }, Z = (i, u, h, _) => {
    [i.el, i.anchor] = x(
      i.children,
      u,
      h,
      _,
      i.el,
      i.anchor
    );
  }, W = (i, u, h, _) => {
    if (u.children !== i.children) {
      const g = E(i.anchor);
      U(i), [u.el, u.anchor] = x(
        u.children,
        h,
        g,
        _
      );
    } else
      u.el = i.el, u.anchor = i.anchor;
  }, he = ({ el: i, anchor: u }, h, _) => {
    let g;
    for (; i && i !== u; )
      g = E(i), n(i, h, _), i = g;
    n(u, h, _);
  }, U = ({ el: i, anchor: u }) => {
    let h;
    for (; i && i !== u; )
      h = E(i), s(i), i = h;
    s(u);
  }, q = (i, u, h, _, g, m, V, O, y) => {
    u.type === "svg" ? V = "svg" : u.type === "math" && (V = "mathml"), i == null ? oe(
      u,
      h,
      _,
      g,
      m,
      V,
      O,
      y
    ) : M(
      i,
      u,
      g,
      m,
      V,
      O,
      y
    );
  }, oe = (i, u, h, _, g, m, V, O) => {
    let y, v;
    const { props: $, shapeFlag: D, transition: w, dirs: F } = i;
    if (y = i.el = l(
      i.type,
      m,
      $ && $.is,
      $
    ), D & 8 ? f(y, i.children) : D & 16 && C(
      i.children,
      y,
      null,
      _,
      g,
      go(i, m),
      V,
      O
    ), F && We(i, null, _, "created"), J(y, i, i.scopeId, V, _), $) {
      for (const B in $)
        B !== "value" && !Et(B) && r(y, B, null, $[B], m, _);
      "value" in $ && r(y, "value", null, $.value, m), (v = $.onVnodeBeforeMount) && Ce(v, _, i);
    }
    process.env.NODE_ENV !== "production" && (Bt(y, "__vnode", i, !0), Bt(y, "__vueParentComponent", _, !0)), F && We(i, null, _, "beforeMount");
    const S = ti(g, w);
    S && w.beforeEnter(y), n(y, u, h), ((v = $ && $.onVnodeMounted) || S || F) && le(() => {
      v && Ce(v, _, i), S && w.enter(y), F && We(i, null, _, "mounted");
    }, g);
  }, J = (i, u, h, _, g) => {
    if (h && b(i, h), _)
      for (let m = 0; m < _.length; m++)
        b(i, _[m]);
    if (g) {
      let m = g.subTree;
      if (process.env.NODE_ENV !== "production" && m.patchFlag > 0 && m.patchFlag & 2048 && (m = qo(m.children) || m), u === m || Nr(m.type) && (m.ssContent === u || m.ssFallback === u)) {
        const V = g.vnode;
        J(
          i,
          V,
          V.scopeId,
          V.slotScopeIds,
          g.parent
        );
      }
    }
  }, C = (i, u, h, _, g, m, V, O, y = 0) => {
    for (let v = y; v < i.length; v++) {
      const $ = i[v] = O ? Le(i[v]) : ye(i[v]);
      T(
        null,
        $,
        u,
        h,
        _,
        g,
        m,
        V,
        O
      );
    }
  }, M = (i, u, h, _, g, m, V) => {
    const O = u.el = i.el;
    process.env.NODE_ENV !== "production" && (O.__vnode = u);
    let { patchFlag: y, dynamicChildren: v, dirs: $ } = u;
    y |= i.patchFlag & 16;
    const D = i.props || H, w = u.props || H;
    let F;
    if (h && qe(h, !1), (F = w.onVnodeBeforeUpdate) && Ce(F, h, u, i), $ && We(u, i, h, "beforeUpdate"), h && qe(h, !0), process.env.NODE_ENV !== "production" && Oe && (y = 0, V = !1, v = null), (D.innerHTML && w.innerHTML == null || D.textContent && w.textContent == null) && f(O, ""), v ? (K(
      i.dynamicChildren,
      v,
      O,
      h,
      _,
      go(u, g),
      m
    ), process.env.NODE_ENV !== "production" && Nt(i, u)) : V || xe(
      i,
      u,
      O,
      null,
      h,
      _,
      go(u, g),
      m,
      !1
    ), y > 0) {
      if (y & 16)
        Q(O, D, w, h, g);
      else if (y & 2 && D.class !== w.class && r(O, "class", null, w.class, g), y & 4 && r(O, "style", D.style, w.style, g), y & 8) {
        const S = u.dynamicProps;
        for (let B = 0; B < S.length; B++) {
          const L = S[B], ae = D[L], re = w[L];
          (re !== ae || L === "value") && r(O, L, ae, re, g, h);
        }
      }
      y & 1 && i.children !== u.children && f(O, u.children);
    } else
      !V && v == null && Q(O, D, w, h, g);
    ((F = w.onVnodeUpdated) || $) && le(() => {
      F && Ce(F, h, u, i), $ && We(u, i, h, "updated");
    }, _);
  }, K = (i, u, h, _, g, m, V) => {
    for (let O = 0; O < u.length; O++) {
      const y = i[O], v = u[O], $ = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        y.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (y.type === de || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Ge(y, v) || // - In the case of a component, it could contain anything.
        y.shapeFlag & 198) ? d(y.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          h
        )
      );
      T(
        y,
        v,
        $,
        null,
        _,
        g,
        m,
        V,
        !0
      );
    }
  }, Q = (i, u, h, _, g) => {
    if (u !== h) {
      if (u !== H)
        for (const m in u)
          !Et(m) && !(m in h) && r(
            i,
            m,
            u[m],
            null,
            g,
            _
          );
      for (const m in h) {
        if (Et(m))
          continue;
        const V = h[m], O = u[m];
        V !== O && m !== "value" && r(i, m, O, V, g, _);
      }
      "value" in h && r(i, "value", u.value, h.value, g);
    }
  }, Ve = (i, u, h, _, g, m, V, O, y) => {
    const v = u.el = i ? i.el : c(""), $ = u.anchor = i ? i.anchor : c("");
    let { patchFlag: D, dynamicChildren: w, slotScopeIds: F } = u;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (Oe || D & 2048) && (D = 0, y = !1, w = null), F && (O = O ? O.concat(F) : F), i == null ? (n(v, h, _), n($, h, _), C(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      u.children || [],
      h,
      $,
      g,
      m,
      V,
      O,
      y
    )) : D > 0 && D & 64 && w && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    i.dynamicChildren ? (K(
      i.dynamicChildren,
      w,
      h,
      g,
      m,
      V,
      O
    ), process.env.NODE_ENV !== "production" ? Nt(i, u) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (u.key != null || g && u === g.subTree) && Nt(
        i,
        u,
        !0
        /* shallow */
      )
    )) : xe(
      i,
      u,
      h,
      $,
      g,
      m,
      V,
      O,
      y
    );
  }, Ke = (i, u, h, _, g, m, V, O, y) => {
    u.slotScopeIds = O, i == null ? u.shapeFlag & 512 ? g.ctx.activate(
      u,
      h,
      _,
      V,
      y
    ) : De(
      u,
      h,
      _,
      g,
      m,
      V,
      y
    ) : fe(i, u, y);
  }, De = (i, u, h, _, g, m, V) => {
    const O = i.component = vi(
      i,
      _,
      g
    );
    if (process.env.NODE_ENV !== "production" && O.type.__hmrId && es(O), process.env.NODE_ENV !== "production" && (kt(i), Ie(O, "mount")), Ct(i) && (O.ctx.renderer = tt), process.env.NODE_ENV !== "production" && Ie(O, "init"), bi(O, !1, V), process.env.NODE_ENV !== "production" && Pe(O, "init"), process.env.NODE_ENV !== "production" && Oe && (i.el = null), O.asyncDep) {
      if (g && g.registerDep(O, k, V), !i.el) {
        const y = O.subTree = pe(G);
        j(null, y, u, h), i.placeholder = y.el;
      }
    } else
      k(
        O,
        i,
        u,
        h,
        g,
        m,
        V
      );
    process.env.NODE_ENV !== "production" && (St(), Pe(O, "mount"));
  }, fe = (i, u, h) => {
    const _ = u.component = i.component;
    if (fi(i, u, h))
      if (_.asyncDep && !_.asyncResolved) {
        process.env.NODE_ENV !== "production" && kt(u), P(_, u, h), process.env.NODE_ENV !== "production" && St();
        return;
      } else
        _.next = u, _.update();
    else
      u.el = i.el, _.vnode = u;
  }, k = (i, u, h, _, g, m, V) => {
    const O = () => {
      if (i.isMounted) {
        let { next: D, bu: w, u: F, parent: S, vnode: B } = i;
        {
          const ge = hr(i);
          if (ge) {
            D && (D.el = B.el, P(i, D, V)), ge.asyncDep.then(() => {
              i.isUnmounted || O();
            });
            return;
          }
        }
        let L = D, ae;
        process.env.NODE_ENV !== "production" && kt(D || i.vnode), qe(i, !1), D ? (D.el = B.el, P(i, D, V)) : D = B, w && dt(w), (ae = D.props && D.props.onVnodeBeforeUpdate) && Ce(ae, S, D, B), qe(i, !0), process.env.NODE_ENV !== "production" && Ie(i, "render");
        const re = mo(i);
        process.env.NODE_ENV !== "production" && Pe(i, "render");
        const ve = i.subTree;
        i.subTree = re, process.env.NODE_ENV !== "production" && Ie(i, "patch"), T(
          ve,
          re,
          // parent may have changed if it's in a teleport
          d(ve.el),
          // anchor may have changed if it's in a fragment
          Ft(ve),
          i,
          g,
          m
        ), process.env.NODE_ENV !== "production" && Pe(i, "patch"), D.el = re.el, L === null && ai(i, re.el), F && le(F, g), (ae = D.props && D.props.onVnodeUpdated) && le(
          () => Ce(ae, S, D, B),
          g
        ), process.env.NODE_ENV !== "production" && Mn(i), process.env.NODE_ENV !== "production" && St();
      } else {
        let D;
        const { el: w, props: F } = u, { bm: S, m: B, parent: L, root: ae, type: re } = i, ve = st(u);
        if (qe(i, !1), S && dt(S), !ve && (D = F && F.onVnodeBeforeMount) && Ce(D, L, u), qe(i, !0), w && uo) {
          const ge = () => {
            process.env.NODE_ENV !== "production" && Ie(i, "render"), i.subTree = mo(i), process.env.NODE_ENV !== "production" && Pe(i, "render"), process.env.NODE_ENV !== "production" && Ie(i, "hydrate"), uo(
              w,
              i.subTree,
              i,
              g,
              null
            ), process.env.NODE_ENV !== "production" && Pe(i, "hydrate");
          };
          ve && re.__asyncHydrate ? re.__asyncHydrate(
            w,
            i,
            ge
          ) : ge();
        } else {
          ae.ce && // @ts-expect-error _def is private
          ae.ce._def.shadowRoot !== !1 && ae.ce._injectChildStyle(re), process.env.NODE_ENV !== "production" && Ie(i, "render");
          const ge = i.subTree = mo(i);
          process.env.NODE_ENV !== "production" && Pe(i, "render"), process.env.NODE_ENV !== "production" && Ie(i, "patch"), T(
            null,
            ge,
            h,
            _,
            i,
            g,
            m
          ), process.env.NODE_ENV !== "production" && Pe(i, "patch"), u.el = ge.el;
        }
        if (B && le(B, g), !ve && (D = F && F.onVnodeMounted)) {
          const ge = u;
          le(
            () => Ce(D, L, ge),
            g
          );
        }
        (u.shapeFlag & 256 || L && st(L.vnode) && L.vnode.shapeFlag & 256) && i.a && le(i.a, g), i.isMounted = !0, process.env.NODE_ENV !== "production" && is(i), u = h = _ = null;
      }
    };
    i.scope.on();
    const y = i.effect = new Mr(O);
    i.scope.off();
    const v = i.update = y.run.bind(y), $ = i.job = y.runIfDirty.bind(y);
    $.i = i, $.id = i.uid, y.scheduler = () => zt($), qe(i, !0), process.env.NODE_ENV !== "production" && (y.onTrack = i.rtc ? (D) => dt(i.rtc, D) : void 0, y.onTrigger = i.rtg ? (D) => dt(i.rtg, D) : void 0), v();
  }, P = (i, u, h) => {
    u.component = i;
    const _ = i.vnode.props;
    i.vnode = u, i.next = null, Us(i, u.props, _, h), Zs(i, u.children, h), ke(), en(i), Se();
  }, xe = (i, u, h, _, g, m, V, O, y = !1) => {
    const v = i && i.children, $ = i ? i.shapeFlag : 0, D = u.children, { patchFlag: w, shapeFlag: F } = u;
    if (w > 0) {
      if (w & 128) {
        ut(
          v,
          D,
          h,
          _,
          g,
          m,
          V,
          O,
          y
        );
        return;
      } else if (w & 256) {
        so(
          v,
          D,
          h,
          _,
          g,
          m,
          V,
          O,
          y
        );
        return;
      }
    }
    F & 8 ? ($ & 16 && ft(v, g, m), D !== v && f(h, D)) : $ & 16 ? F & 16 ? ut(
      v,
      D,
      h,
      _,
      g,
      m,
      V,
      O,
      y
    ) : ft(v, g, m, !0) : ($ & 8 && f(h, ""), F & 16 && C(
      D,
      h,
      _,
      g,
      m,
      V,
      O,
      y
    ));
  }, so = (i, u, h, _, g, m, V, O, y) => {
    i = i || nt, u = u || nt;
    const v = i.length, $ = u.length, D = Math.min(v, $);
    let w;
    for (w = 0; w < D; w++) {
      const F = u[w] = y ? Le(u[w]) : ye(u[w]);
      T(
        i[w],
        F,
        h,
        null,
        g,
        m,
        V,
        O,
        y
      );
    }
    v > $ ? ft(
      i,
      g,
      m,
      !0,
      !1,
      D
    ) : C(
      u,
      h,
      _,
      g,
      m,
      V,
      O,
      y,
      D
    );
  }, ut = (i, u, h, _, g, m, V, O, y) => {
    let v = 0;
    const $ = u.length;
    let D = i.length - 1, w = $ - 1;
    for (; v <= D && v <= w; ) {
      const F = i[v], S = u[v] = y ? Le(u[v]) : ye(u[v]);
      if (Ge(F, S))
        T(
          F,
          S,
          h,
          null,
          g,
          m,
          V,
          O,
          y
        );
      else
        break;
      v++;
    }
    for (; v <= D && v <= w; ) {
      const F = i[D], S = u[w] = y ? Le(u[w]) : ye(u[w]);
      if (Ge(F, S))
        T(
          F,
          S,
          h,
          null,
          g,
          m,
          V,
          O,
          y
        );
      else
        break;
      D--, w--;
    }
    if (v > D) {
      if (v <= w) {
        const F = w + 1, S = F < $ ? u[F].el : _;
        for (; v <= w; )
          T(
            null,
            u[v] = y ? Le(u[v]) : ye(u[v]),
            h,
            S,
            g,
            m,
            V,
            O,
            y
          ), v++;
      }
    } else if (v > w)
      for (; v <= D; )
        je(i[v], g, m, !0), v++;
    else {
      const F = v, S = v, B = /* @__PURE__ */ new Map();
      for (v = S; v <= w; v++) {
        const se = u[v] = y ? Le(u[v]) : ye(u[v]);
        se.key != null && (process.env.NODE_ENV !== "production" && B.has(se.key) && N(
          "Duplicate keys found during update:",
          JSON.stringify(se.key),
          "Make sure keys are unique."
        ), B.set(se.key, v));
      }
      let L, ae = 0;
      const re = w - S + 1;
      let ve = !1, ge = 0;
      const at = new Array(re);
      for (v = 0; v < re; v++)
        at[v] = 0;
      for (v = F; v <= D; v++) {
        const se = i[v];
        if (ae >= re) {
          je(se, g, m, !0);
          continue;
        }
        let we;
        if (se.key != null)
          we = B.get(se.key);
        else
          for (L = S; L <= w; L++)
            if (at[L - S] === 0 && Ge(se, u[L])) {
              we = L;
              break;
            }
        we === void 0 ? je(se, g, m, !0) : (at[we - S] = v + 1, we >= ge ? ge = we : ve = !0, T(
          se,
          u[we],
          h,
          null,
          g,
          m,
          V,
          O,
          y
        ), ae++);
      }
      const Qo = ve ? oi(at) : nt;
      for (L = Qo.length - 1, v = re - 1; v >= 0; v--) {
        const se = S + v, we = u[se], Xo = u[se + 1], Zo = se + 1 < $ ? (
          // #13559, fallback to el placeholder for unresolved async component
          Xo.el || Xo.placeholder
        ) : _;
        at[v] === 0 ? T(
          null,
          we,
          h,
          Zo,
          g,
          m,
          V,
          O,
          y
        ) : ve && (L < 0 || v !== Qo[L] ? et(we, h, Zo, 2) : L--);
      }
    }
  }, et = (i, u, h, _, g = null) => {
    const { el: m, type: V, transition: O, children: y, shapeFlag: v } = i;
    if (v & 6) {
      et(i.component.subTree, u, h, _);
      return;
    }
    if (v & 128) {
      i.suspense.move(u, h, _);
      return;
    }
    if (v & 64) {
      V.move(i, u, h, tt);
      return;
    }
    if (V === de) {
      n(m, u, h);
      for (let D = 0; D < y.length; D++)
        et(y[D], u, h, _);
      n(i.anchor, u, h);
      return;
    }
    if (V === Ht) {
      he(i, u, h);
      return;
    }
    if (_ !== 2 && v & 1 && O)
      if (_ === 0)
        O.beforeEnter(m), n(m, u, h), le(() => O.enter(m), g);
      else {
        const { leave: D, delayLeave: w, afterLeave: F } = O, S = () => {
          i.ctx.isUnmounted ? s(m) : n(m, u, h);
        }, B = () => {
          D(m, () => {
            S(), F && F();
          });
        };
        w ? w(m, S, B) : B();
      }
    else
      n(m, u, h);
  }, je = (i, u, h, _ = !1, g = !1) => {
    const {
      type: m,
      props: V,
      ref: O,
      children: y,
      dynamicChildren: v,
      shapeFlag: $,
      patchFlag: D,
      dirs: w,
      cacheIndex: F
    } = i;
    if (D === -2 && (g = !1), O != null && (ke(), mt(O, null, h, i, !0), Se()), F != null && (u.renderCache[F] = void 0), $ & 256) {
      u.ctx.deactivate(i);
      return;
    }
    const S = $ & 1 && w, B = !st(i);
    let L;
    if (B && (L = V && V.onVnodeBeforeUnmount) && Ce(L, u, i), $ & 6)
      Cr(i.component, h, _);
    else {
      if ($ & 128) {
        i.suspense.unmount(h, _);
        return;
      }
      S && We(i, null, u, "beforeUnmount"), $ & 64 ? i.type.remove(
        i,
        u,
        h,
        tt,
        _
      ) : v && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !v.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (m !== de || D > 0 && D & 64) ? ft(
        v,
        u,
        h,
        !1,
        !0
      ) : (m === de && D & 384 || !g && $ & 16) && ft(y, u, h), _ && io(i);
    }
    (B && (L = V && V.onVnodeUnmounted) || S) && le(() => {
      L && Ce(L, u, i), S && We(i, null, u, "unmounted");
    }, h);
  }, io = (i) => {
    const { type: u, el: h, anchor: _, transition: g } = i;
    if (u === de) {
      process.env.NODE_ENV !== "production" && i.patchFlag > 0 && i.patchFlag & 2048 && g && !g.persisted ? i.children.forEach((V) => {
        V.type === G ? s(V.el) : io(V);
      }) : wr(h, _);
      return;
    }
    if (u === Ht) {
      U(i);
      return;
    }
    const m = () => {
      s(h), g && !g.persisted && g.afterLeave && g.afterLeave();
    };
    if (i.shapeFlag & 1 && g && !g.persisted) {
      const { leave: V, delayLeave: O } = g, y = () => V(h, m);
      O ? O(i.el, m, y) : y();
    } else
      m();
  }, wr = (i, u) => {
    let h;
    for (; i !== u; )
      h = E(i), s(i), i = h;
    s(u);
  }, Cr = (i, u, h) => {
    process.env.NODE_ENV !== "production" && i.type.__hmrId && ts(i);
    const {
      bum: _,
      scope: g,
      job: m,
      subTree: V,
      um: O,
      m: y,
      a: v,
      parent: $,
      slots: { __: D }
    } = i;
    gn(y), gn(v), _ && dt(_), $ && I(D) && D.forEach((w) => {
      $.renderCache[w] = void 0;
    }), g.stop(), m && (m.flags |= 8, je(V, i, u, h)), O && le(O, u), le(() => {
      i.isUnmounted = !0;
    }, u), u && u.pendingBranch && !u.isUnmounted && i.asyncDep && !i.asyncResolved && i.suspenseId === u.pendingId && (u.deps--, u.deps === 0 && u.resolve()), process.env.NODE_ENV !== "production" && cs(i);
  }, ft = (i, u, h, _ = !1, g = !1, m = 0) => {
    for (let V = m; V < i.length; V++)
      je(i[V], u, h, _, g);
  }, Ft = (i) => {
    if (i.shapeFlag & 6)
      return Ft(i.component.subTree);
    if (i.shapeFlag & 128)
      return i.suspense.next();
    const u = E(i.anchor || i.el), h = u && u[Ln];
    return h ? E(h) : u;
  };
  let lo = !1;
  const Yo = (i, u, h) => {
    i == null ? u._vnode && je(u._vnode, null, null, !0) : T(
      u._vnode || null,
      i,
      u,
      null,
      null,
      null,
      h
    ), u._vnode = i, lo || (lo = !0, en(), Pn(), lo = !1);
  }, tt = {
    p: T,
    um: je,
    m: et,
    r: io,
    mt: De,
    mc: C,
    pc: xe,
    pbc: K,
    n: Ft,
    o: e
  };
  let co, uo;
  return t && ([co, uo] = t(
    tt
  )), {
    render: Yo,
    hydrate: co,
    createApp: js(Yo, co)
  };
}
function go({ type: e, props: t }, o) {
  return o === "svg" && e === "foreignObject" || o === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : o;
}
function qe({ effect: e, job: t }, o) {
  o ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function ti(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Nt(e, t, o = !1) {
  const n = e.children, s = t.children;
  if (I(n) && I(s))
    for (let r = 0; r < n.length; r++) {
      const l = n[r];
      let c = s[r];
      c.shapeFlag & 1 && !c.dynamicChildren && ((c.patchFlag <= 0 || c.patchFlag === 32) && (c = s[r] = Le(s[r]), c.el = l.el), !o && c.patchFlag !== -2 && Nt(l, c)), c.type === Tt && (c.el = l.el), c.type === G && !c.el && (c.el = l.el), process.env.NODE_ENV !== "production" && c.el && (c.el.__vnode = c);
    }
}
function oi(e) {
  const t = e.slice(), o = [0];
  let n, s, r, l, c;
  const a = e.length;
  for (n = 0; n < a; n++) {
    const p = e[n];
    if (p !== 0) {
      if (s = o[o.length - 1], e[s] < p) {
        t[n] = s, o.push(n);
        continue;
      }
      for (r = 0, l = o.length - 1; r < l; )
        c = r + l >> 1, e[o[c]] < p ? r = c + 1 : l = c;
      p < e[o[r]] && (r > 0 && (t[n] = o[r - 1]), o[r] = n);
    }
  }
  for (r = o.length, l = o[r - 1]; r-- > 0; )
    o[r] = l, l = t[l];
  return o;
}
function hr(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : hr(t);
}
function gn(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const ni = Symbol.for("v-scx"), ri = () => {
  {
    const e = Rt(ni);
    return e || process.env.NODE_ENV !== "production" && N(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Ki(e, t) {
  return Wo(e, null, t);
}
function Eo(e, t, o) {
  return process.env.NODE_ENV !== "production" && !A(t) && N(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), Wo(e, t, o);
}
function Wo(e, t, o = H) {
  const { immediate: n, deep: s, flush: r, once: l } = o;
  process.env.NODE_ENV !== "production" && !t && (n !== void 0 && N(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), s !== void 0 && N(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), l !== void 0 && N(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const c = ee({}, o);
  process.env.NODE_ENV !== "production" && (c.onWarn = N);
  const a = t && n || !t && r !== "post";
  let p;
  if (Vt) {
    if (r === "sync") {
      const b = ri();
      p = b.__watcherHandles || (b.__watcherHandles = []);
    } else if (!a) {
      const b = () => {
      };
      return b.stop = ne, b.resume = ne, b.pause = ne, b;
    }
  }
  const f = z;
  c.call = (b, x, T) => Fe(b, f, x, T);
  let d = !1;
  r === "post" ? c.scheduler = (b) => {
    le(b, f && f.suspense);
  } : r !== "sync" && (d = !0, c.scheduler = (b, x) => {
    x ? b() : zt(b);
  }), c.augmentJob = (b) => {
    t && (b.flags |= 4), d && (b.flags |= 2, f && (b.id = f.uid, b.i = f));
  };
  const E = Tr(e, t, c);
  return Vt && (p ? p.push(E) : a && E()), E;
}
function si(e, t, o) {
  const n = this.proxy, s = ue(e) ? e.includes(".") ? gr(n, e) : () => n[e] : e.bind(n, n);
  let r;
  A(t) ? r = t : (r = t.handler, o = t);
  const l = $t(this), c = Wo(s, r.bind(n), o);
  return l(), c;
}
function gr(e, t) {
  const o = t.split(".");
  return () => {
    let n = e;
    for (let s = 0; s < o.length && n; s++)
      n = n[o[s]];
    return n;
  };
}
const ii = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${me(t)}Modifiers`] || e[`${lt(t)}Modifiers`];
function li(e, t, ...o) {
  if (e.isUnmounted)
    return;
  const n = e.vnode.props || H;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: f,
      propsOptions: [d]
    } = e;
    if (f)
      if (!(t in f))
        (!d || !(Je(me(t)) in d)) && N(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${Je(me(t))}" prop.`
        );
      else {
        const E = f[t];
        A(E) && (E(...o) || N(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let s = o;
  const r = t.startsWith("update:"), l = r && ii(n, t.slice(7));
  if (l && (l.trim && (s = o.map((f) => ue(f) ? f.trim() : f)), l.number && (s = o.map(Wr))), process.env.NODE_ENV !== "production" && as(e, t, s), process.env.NODE_ENV !== "production") {
    const f = t.toLowerCase();
    f !== t && n[Je(f)] && N(
      `Event "${f}" is emitted in component ${ro(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${lt(
        t
      )}" instead of "${t}".`
    );
  }
  let c, a = n[c = Je(t)] || // also try camelCase event handler (#2249)
  n[c = Je(me(t))];
  !a && r && (a = n[c = Je(lt(t))]), a && Fe(
    a,
    e,
    6,
    s
  );
  const p = n[c + "Once"];
  if (p) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[c])
      return;
    e.emitted[c] = !0, Fe(
      p,
      e,
      6,
      s
    );
  }
}
function Er(e, t, o = !1) {
  const n = t.emitsCache, s = n.get(e);
  if (s !== void 0)
    return s;
  const r = e.emits;
  let l = {}, c = !1;
  if (!A(e)) {
    const a = (p) => {
      const f = Er(p, t, !0);
      f && (c = !0, ee(l, f));
    };
    !o && t.mixins.length && t.mixins.forEach(a), e.extends && a(e.extends), e.mixins && e.mixins.forEach(a);
  }
  return !r && !c ? (X(e) && n.set(e, null), null) : (I(r) ? r.forEach((a) => l[a] = null) : ee(l, r), X(e) && n.set(e, l), l);
}
function to(e, t) {
  return !e || !Zt(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), R(e, t[0].toLowerCase() + t.slice(1)) || R(e, lt(t)) || R(e, t));
}
let To = !1;
function Qt() {
  To = !0;
}
function mo(e) {
  const {
    type: t,
    vnode: o,
    proxy: n,
    withProxy: s,
    propsOptions: [r],
    slots: l,
    attrs: c,
    emit: a,
    render: p,
    renderCache: f,
    props: d,
    data: E,
    setupState: b,
    ctx: x,
    inheritAttrs: T
  } = e, te = qt(e);
  let j, Z;
  process.env.NODE_ENV !== "production" && (To = !1);
  try {
    if (o.shapeFlag & 4) {
      const U = s || n, q = process.env.NODE_ENV !== "production" && b.__isScriptSetup ? new Proxy(U, {
        get(oe, J, C) {
          return N(
            `Property '${String(
              J
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(oe, J, C);
        }
      }) : U;
      j = ye(
        p.call(
          q,
          U,
          f,
          process.env.NODE_ENV !== "production" ? $e(d) : d,
          b,
          E,
          x
        )
      ), Z = c;
    } else {
      const U = t;
      process.env.NODE_ENV !== "production" && c === d && Qt(), j = ye(
        U.length > 1 ? U(
          process.env.NODE_ENV !== "production" ? $e(d) : d,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return Qt(), $e(c);
            },
            slots: l,
            emit: a
          } : { attrs: c, slots: l, emit: a }
        ) : U(
          process.env.NODE_ENV !== "production" ? $e(d) : d,
          null
        )
      ), Z = t.props ? c : ci(c);
    }
  } catch (U) {
    _t.length = 0, xt(U, e, 1), j = pe(G);
  }
  let W = j, he;
  if (process.env.NODE_ENV !== "production" && j.patchFlag > 0 && j.patchFlag & 2048 && ([W, he] = mr(j)), Z && T !== !1) {
    const U = Object.keys(Z), { shapeFlag: q } = W;
    if (U.length) {
      if (q & 7)
        r && U.some(vo) && (Z = ui(
          Z,
          r
        )), W = Ae(W, Z, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !To && W.type !== G) {
        const oe = Object.keys(c), J = [], C = [];
        for (let M = 0, K = oe.length; M < K; M++) {
          const Q = oe[M];
          Zt(Q) ? vo(Q) || J.push(Q[2].toLowerCase() + Q.slice(3)) : C.push(Q);
        }
        C.length && N(
          `Extraneous non-props attributes (${C.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), J.length && N(
          `Extraneous non-emits event listeners (${J.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return o.dirs && (process.env.NODE_ENV !== "production" && !En(W) && N(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), W = Ae(W, null, !1, !0), W.dirs = W.dirs ? W.dirs.concat(o.dirs) : o.dirs), o.transition && (process.env.NODE_ENV !== "production" && !En(W) && N(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), bt(W, o.transition)), process.env.NODE_ENV !== "production" && he ? he(W) : j = W, qt(te), j;
}
const mr = (e) => {
  const t = e.children, o = e.dynamicChildren, n = qo(t, !1);
  if (n) {
    if (process.env.NODE_ENV !== "production" && n.patchFlag > 0 && n.patchFlag & 2048)
      return mr(n);
  } else
    return [e, void 0];
  const s = t.indexOf(n), r = o ? o.indexOf(n) : -1, l = (c) => {
    t[s] = c, o && (r > -1 ? o[r] = c : c.patchFlag > 0 && (e.dynamicChildren = [...o, c]));
  };
  return [ye(n), l];
};
function qo(e, t = !0) {
  let o;
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    if (ze(s)) {
      if (s.type !== G || s.children === "v-if") {
        if (o)
          return;
        if (o = s, process.env.NODE_ENV !== "production" && t && o.patchFlag > 0 && o.patchFlag & 2048)
          return qo(o.children);
      }
    } else
      return;
  }
  return o;
}
const ci = (e) => {
  let t;
  for (const o in e)
    (o === "class" || o === "style" || Zt(o)) && ((t || (t = {}))[o] = e[o]);
  return t;
}, ui = (e, t) => {
  const o = {};
  for (const n in e)
    (!vo(n) || !(n.slice(9) in t)) && (o[n] = e[n]);
  return o;
}, En = (e) => e.shapeFlag & 7 || e.type === G;
function fi(e, t, o) {
  const { props: n, children: s, component: r } = e, { props: l, children: c, patchFlag: a } = t, p = r.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (s || c) && Oe || t.dirs || t.transition)
    return !0;
  if (o && a >= 0) {
    if (a & 1024)
      return !0;
    if (a & 16)
      return n ? mn(n, l, p) : !!l;
    if (a & 8) {
      const f = t.dynamicProps;
      for (let d = 0; d < f.length; d++) {
        const E = f[d];
        if (l[E] !== n[E] && !to(p, E))
          return !0;
      }
    }
  } else
    return (s || c) && (!c || !c.$stable) ? !0 : n === l ? !1 : n ? l ? mn(n, l, p) : !0 : !!l;
  return !1;
}
function mn(e, t, o) {
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !0;
  for (let s = 0; s < n.length; s++) {
    const r = n[s];
    if (t[r] !== e[r] && !to(o, r))
      return !0;
  }
  return !1;
}
function ai({ vnode: e, parent: t }, o) {
  for (; t; ) {
    const n = t.subTree;
    if (n.suspense && n.suspense.activeBranch === e && (n.el = e.el), n === e)
      (e = t.vnode).el = o, t = t.parent;
    else
      break;
  }
}
const Nr = (e) => e.__isSuspense;
function di(e, t) {
  t && t.pendingBranch ? I(e) ? t.effects.push(...e) : t.effects.push(e) : In(e);
}
const de = Symbol.for("v-fgt"), Tt = Symbol.for("v-txt"), G = Symbol.for("v-cmt"), Ht = Symbol.for("v-stc"), _t = [];
let Ee = null;
function $o(e = !1) {
  _t.push(Ee = e ? null : []);
}
function pi() {
  _t.pop(), Ee = _t[_t.length - 1] || null;
}
let Ot = 1;
function Nn(e, t = !1) {
  Ot += e, e < 0 && Ee && t && (Ee.hasOnce = !0);
}
function _r(e) {
  return e.dynamicChildren = Ot > 0 ? Ee || nt : null, pi(), Ot > 0 && Ee && Ee.push(e), e;
}
function Wi(e, t, o, n, s, r) {
  return _r(
    yr(
      e,
      t,
      o,
      n,
      s,
      r,
      !0
    )
  );
}
function Fo(e, t, o, n, s) {
  return _r(
    pe(
      e,
      t,
      o,
      n,
      s,
      !0
    )
  );
}
function ze(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Ge(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const o = Mt.get(t.type);
    if (o && o.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const hi = (...e) => br(
  ...e
), vr = ({ key: e }) => e != null ? e : null, Lt = ({
  ref: e,
  ref_key: t,
  ref_for: o
}) => (typeof e == "number" && (e = "" + e), e != null ? ue(e) || Be(e) || A(e) ? { i: Y, r: e, k: t, f: !!o } : e : null);
function yr(e, t = null, o = null, n = 0, s = null, r = e === de ? 0 : 1, l = !1, c = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && vr(t),
    ref: t && Lt(t),
    scopeId: Rn,
    slotScopeIds: null,
    children: o,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: n,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: Y
  };
  return c ? (Jo(a, o), r & 128 && e.normalize(a)) : o && (a.shapeFlag |= ue(o) ? 8 : 16), process.env.NODE_ENV !== "production" && a.key !== a.key && N("VNode created with invalid key (NaN). VNode type:", a.type), Ot > 0 && // avoid a block node from tracking itself
  !l && // has current parent block
  Ee && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (a.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  a.patchFlag !== 32 && Ee.push(a), a;
}
const pe = process.env.NODE_ENV !== "production" ? hi : br;
function br(e, t = null, o = null, n = 0, s = null, r = !1) {
  if ((!e || e === tr) && (process.env.NODE_ENV !== "production" && !e && N(`Invalid vnode type when creating vnode: ${e}.`), e = G), ze(e)) {
    const c = Ae(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return o && Jo(c, o), Ot > 0 && !r && Ee && (c.shapeFlag & 6 ? Ee[Ee.indexOf(e)] = c : Ee.push(c)), c.patchFlag = -2, c;
  }
  if (xr(e) && (e = e.__vccOpts), t) {
    t = gi(t);
    let { class: c, style: a } = t;
    c && !ue(c) && (t.class = xn(c)), X(a) && (No(a) && !I(a) && (a = ee({}, a)), t.style = wn(a));
  }
  const l = ue(e) ? 1 : Nr(e) ? 128 : Un(e) ? 64 : X(e) ? 4 : A(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && l & 4 && No(e) && (e = _e(e), N(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), yr(
    e,
    t,
    o,
    n,
    s,
    l,
    r,
    !0
  );
}
function gi(e) {
  return e ? No(e) || cr(e) ? ee({}, e) : e : null;
}
function Ae(e, t, o = !1, n = !1) {
  const { props: s, ref: r, patchFlag: l, children: c, transition: a } = e, p = t ? mi(s || {}, t) : s, f = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: p,
    key: p && vr(p),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      o && r ? I(r) ? r.concat(Lt(t)) : [r, Lt(t)] : Lt(t)
    ) : r,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && l === -1 && I(c) ? c.map(Or) : c,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== de ? l === -1 ? 16 : l | 16 : l,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: a,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Ae(e.ssContent),
    ssFallback: e.ssFallback && Ae(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return a && n && bt(
    f,
    a.clone(f)
  ), f;
}
function Or(e) {
  const t = Ae(e);
  return I(e.children) && (t.children = e.children.map(Or)), t;
}
function Ei(e = " ", t = 0) {
  return pe(Tt, null, e, t);
}
function qi(e = "", t = !1) {
  return t ? ($o(), Fo(G, null, e)) : pe(G, null, e);
}
function ye(e) {
  return e == null || typeof e == "boolean" ? pe(G) : I(e) ? pe(
    de,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : ze(e) ? Le(e) : pe(Tt, null, String(e));
}
function Le(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Ae(e);
}
function Jo(e, t) {
  let o = 0;
  const { shapeFlag: n } = e;
  if (t == null)
    t = null;
  else if (I(t))
    o = 16;
  else if (typeof t == "object")
    if (n & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), Jo(e, s()), s._c && (s._d = !0));
      return;
    } else {
      o = 32;
      const s = t._;
      !s && !cr(t) ? t._ctx = Y : s === 3 && Y && (Y.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else
    A(t) ? (t = { default: t, _ctx: Y }, o = 32) : (t = String(t), n & 64 ? (o = 16, t = [Ei(t)]) : o = 8);
  e.children = t, e.shapeFlag |= o;
}
function mi(...e) {
  const t = {};
  for (let o = 0; o < e.length; o++) {
    const n = e[o];
    for (const s in n)
      if (s === "class")
        t.class !== n.class && (t.class = xn([t.class, n.class]));
      else if (s === "style")
        t.style = wn([t.style, n.style]);
      else if (Zt(s)) {
        const r = t[s], l = n[s];
        l && r !== l && !(I(r) && r.includes(l)) && (t[s] = r ? [].concat(r, l) : l);
      } else
        s !== "" && (t[s] = n[s]);
  }
  return t;
}
function Ce(e, t, o, n = null) {
  Fe(e, t, 7, [
    o,
    n
  ]);
}
const Ni = sr();
let _i = 0;
function vi(e, t, o) {
  const n = e.type, s = (t ? t.appContext : e.appContext) || Ni, r = {
    uid: _i++,
    vnode: e,
    type: n,
    parent: t,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new jr(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(s.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: fr(n, s),
    emitsOptions: Er(n, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: H,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: H,
    data: H,
    props: H,
    attrs: H,
    slots: H,
    refs: H,
    setupState: H,
    setupContext: null,
    // suspense related
    suspense: o,
    suspenseId: o ? o.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? r.ctx = Cs(r) : r.ctx = { _: r }, r.root = t ? t.root : r, r.emit = li.bind(null, r), e.ce && e.ce(r), r;
}
let z = null;
const oo = () => z || Y;
let Xt, Ao;
{
  const e = Dt(), t = (o, n) => {
    let s;
    return (s = e[o]) || (s = e[o] = []), s.push(n), (r) => {
      s.length > 1 ? s.forEach((l) => l(r)) : s[0](r);
    };
  };
  Xt = t(
    "__VUE_INSTANCE_SETTERS__",
    (o) => z = o
  ), Ao = t(
    "__VUE_SSR_SETTERS__",
    (o) => Vt = o
  );
}
const $t = (e) => {
  const t = z;
  return Xt(e), e.scope.on(), () => {
    e.scope.off(), Xt(t);
  };
}, _n = () => {
  z && z.scope.off(), Xt(null);
}, yi = /* @__PURE__ */ Tn("slot,component");
function Io(e, { isNativeTag: t }) {
  (yi(e) || t(e)) && N(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function Vr(e) {
  return e.vnode.shapeFlag & 4;
}
let Vt = !1;
function bi(e, t = !1, o = !1) {
  t && Ao(t);
  const { props: n, children: s } = e.vnode, r = Vr(e);
  Hs(e, n, r, t), Xs(e, s, o || t);
  const l = r ? Oi(e, t) : void 0;
  return t && Ao(!1), l;
}
function Oi(e, t) {
  var o;
  const n = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (n.name && Io(n.name, e.appContext.config), n.components) {
      const r = Object.keys(n.components);
      for (let l = 0; l < r.length; l++)
        Io(r[l], e.appContext.config);
    }
    if (n.directives) {
      const r = Object.keys(n.directives);
      for (let l = 0; l < r.length; l++)
        Hn(r[l]);
    }
    n.compilerOptions && Vi() && N(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, nr), process.env.NODE_ENV !== "production" && Ts(e);
  const { setup: s } = n;
  if (s) {
    ke();
    const r = e.setupContext = s.length > 1 ? xi(e) : null, l = $t(e), c = ct(
      s,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? $e(e.props) : e.props,
        r
      ]
    ), a = ko(c);
    if (Se(), l(), (a || e.sp) && !st(e) && Yn(e), a) {
      if (c.then(_n, _n), t)
        return c.then((p) => {
          vn(e, p, t);
        }).catch((p) => {
          xt(p, e, 0);
        });
      if (e.asyncDep = c, process.env.NODE_ENV !== "production" && !e.suspense) {
        const p = (o = n.name) != null ? o : "Anonymous";
        N(
          `Component <${p}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      vn(e, c, t);
  } else
    Dr(e, t);
}
function vn(e, t, o) {
  A(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : X(t) ? (process.env.NODE_ENV !== "production" && ze(t) && N(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = Vn(t), process.env.NODE_ENV !== "production" && $s(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && N(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), Dr(e, o);
}
let Po;
const Vi = () => !Po;
function Dr(e, t, o) {
  const n = e.type;
  if (!e.render) {
    if (!t && Po && !n.render) {
      const s = n.template || Uo(e).template;
      if (s) {
        process.env.NODE_ENV !== "production" && Ie(e, "compile");
        const { isCustomElement: r, compilerOptions: l } = e.appContext.config, { delimiters: c, compilerOptions: a } = n, p = ee(
          ee(
            {
              isCustomElement: r,
              delimiters: c
            },
            l
          ),
          a
        );
        n.render = Po(s, p), process.env.NODE_ENV !== "production" && Pe(e, "compile");
      }
    }
    e.render = n.render || ne;
  }
  {
    const s = $t(e);
    ke();
    try {
      As(e);
    } finally {
      Se(), s();
    }
  }
  process.env.NODE_ENV !== "production" && !n.render && e.render === ne && !t && (n.template ? N(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : N("Component is missing template or render function: ", n));
}
const yn = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return Qt(), vt(e, "get", ""), e[t];
  },
  set() {
    return N("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return N("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return vt(e, "get", ""), e[t];
  }
};
function Di(e) {
  return new Proxy(e.slots, {
    get(t, o) {
      return vt(e, "get", "$slots"), t[o];
    }
  });
}
function xi(e) {
  const t = (o) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && N("expose() should be called only once per setup()."), o != null)) {
      let n = typeof o;
      n === "object" && (I(o) ? n = "array" : Be(o) && (n = "ref")), n !== "object" && N(
        `expose() should be passed a plain object, received ${n}.`
      );
    }
    e.exposed = o || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let o, n;
    return Object.freeze({
      get attrs() {
        return o || (o = new Proxy(e.attrs, yn));
      },
      get slots() {
        return n || (n = Di(e));
      },
      get emit() {
        return (s, ...r) => e.emit(s, ...r);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, yn),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function no(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Vn(Ir(e.exposed)), {
    get(t, o) {
      if (o in t)
        return t[o];
      if (o in Xe)
        return Xe[o](e);
    },
    has(t, o) {
      return o in t || o in Xe;
    }
  })) : e.proxy;
}
const wi = /(?:^|[-_])(\w)/g, Ci = (e) => e.replace(wi, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Go(e, t = !0) {
  return A(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function ro(e, t, o = !1) {
  let n = Go(t);
  if (!n && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (n = s[1]);
  }
  if (!n && e && e.parent) {
    const s = (r) => {
      for (const l in r)
        if (r[l] === t)
          return l;
    };
    n = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return n ? Ci(n) : o ? "App" : "Anonymous";
}
function xr(e) {
  return A(e) && "__vccOpts" in e;
}
const Ti = (e, t) => {
  const o = $r(e, t, Vt);
  if (process.env.NODE_ENV !== "production") {
    const n = oo();
    n && n.appContext.config.warnRecursiveComputed && (o._warnRecursive = !0);
  }
  return o;
};
function Ji(e, t, o) {
  const n = arguments.length;
  return n === 2 ? X(t) && !I(t) ? ze(t) ? pe(e, null, [t]) : pe(e, t) : pe(e, null, t) : (n > 3 ? o = Array.prototype.slice.call(arguments, 2) : n === 3 && ze(o) && (o = [o]), pe(e, t, o));
}
function Gi() {
  if (process.env.NODE_ENV === "production" || typeof window == "undefined")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, o = { style: "color:#f5222d" }, n = { style: "color:#eb2f96" }, s = {
    __vue_custom_formatter: !0,
    header(d) {
      if (!X(d))
        return null;
      if (d.__isVue)
        return ["div", e, "VueInstance"];
      if (Be(d)) {
        ke();
        const E = d.value;
        return Se(), [
          "div",
          {},
          ["span", e, f(d)],
          "<",
          c(E),
          ">"
        ];
      } else {
        if (On(d))
          return [
            "div",
            {},
            ["span", e, Pt(d) ? "ShallowReactive" : "Reactive"],
            "<",
            c(d),
            `>${_o(d) ? " (readonly)" : ""}`
          ];
        if (_o(d))
          return [
            "div",
            {},
            ["span", e, Pt(d) ? "ShallowReadonly" : "Readonly"],
            "<",
            c(d),
            ">"
          ];
      }
      return null;
    },
    hasBody(d) {
      return d && d.__isVue;
    },
    body(d) {
      if (d && d.__isVue)
        return [
          "div",
          {},
          ...r(d.$)
        ];
    }
  };
  function r(d) {
    const E = [];
    d.type.props && d.props && E.push(l("props", _e(d.props))), d.setupState !== H && E.push(l("setup", d.setupState)), d.data !== H && E.push(l("data", _e(d.data)));
    const b = a(d, "computed");
    b && E.push(l("computed", b));
    const x = a(d, "inject");
    return x && E.push(l("injected", x)), E.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: d }]
    ]), E;
  }
  function l(d, E) {
    return E = ee({}, E), Object.keys(E).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        d
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(E).map((b) => [
          "div",
          {},
          ["span", n, b + ": "],
          c(E[b], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function c(d, E = !0) {
    return typeof d == "number" ? ["span", t, d] : typeof d == "string" ? ["span", o, JSON.stringify(d)] : typeof d == "boolean" ? ["span", n, d] : X(d) ? ["object", { object: E ? _e(d) : d }] : ["span", o, String(d)];
  }
  function a(d, E) {
    const b = d.type;
    if (A(b))
      return;
    const x = {};
    for (const T in d.ctx)
      p(b, T, E) && (x[T] = d.ctx[T]);
    return x;
  }
  function p(d, E, b) {
    const x = d[b];
    if (I(x) && x.includes(E) || X(x) && E in x || d.extends && p(d.extends, E, b) || d.mixins && d.mixins.some((T) => p(T, E, b)))
      return !0;
  }
  function f(d) {
    return Pt(d) ? "ShallowRef" : d.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
const bn = "3.5.18", Yi = process.env.NODE_ENV !== "production" ? N : ne;
process.env.NODE_ENV;
process.env.NODE_ENV;
export {
  ki as BaseTransition,
  gs as BaseTransitionPropsValidators,
  G as Comment,
  jr as EffectScope,
  de as Fragment,
  Mr as ReactiveEffect,
  Ht as Static,
  Pi as Teleport,
  Tt as Text,
  Ai as assertNumber,
  Fe as callWithAsyncErrorHandling,
  ct as callWithErrorHandling,
  me as camelize,
  Ut as capitalize,
  Ae as cloneVNode,
  Ti as computed,
  Fo as createBlock,
  qi as createCommentVNode,
  Wi as createElementBlock,
  yr as createElementVNode,
  Bi as createRenderer,
  Ei as createTextVNode,
  pe as createVNode,
  Si as defineComponent,
  Zi as effectScope,
  oo as getCurrentInstance,
  zi as getCurrentScope,
  Gn as getTransitionRawChildren,
  gi as guardReactiveProps,
  Ji as h,
  xt as handleError,
  Gi as initCustomFormatter,
  Rt as inject,
  No as isProxy,
  On as isReactive,
  _o as isReadonly,
  Be as isRef,
  Vi as isRuntimeOnly,
  Pt as isShallow,
  ze as isVNode,
  Ir as markRaw,
  mi as mergeProps,
  Zr as nextTick,
  xn as normalizeClass,
  wn as normalizeStyle,
  ms as onActivated,
  vs as onBeforeMount,
  zn as onBeforeUnmount,
  ys as onBeforeUpdate,
  Ns as onDeactivated,
  xs as onErrorCaptured,
  Zn as onMounted,
  Ds as onRenderTracked,
  Vs as onRenderTriggered,
  Os as onServerPrefetch,
  er as onUnmounted,
  bs as onUpdated,
  el as onWatcherCleanup,
  $o as openBlock,
  Rs as provide,
  Vn as proxyRefs,
  In as queuePostFlushCb,
  Rr as reactive,
  Ar as readonly,
  tl as ref,
  Li as renderList,
  Ui as renderSlot,
  ji as resolveComponent,
  Hi as resolveDirective,
  Ri as resolveDynamicComponent,
  Oo as resolveTransitionHooks,
  Nn as setBlockTracking,
  bt as setTransitionHooks,
  Hr as shallowReactive,
  $e as shallowReadonly,
  Fr as shallowRef,
  ni as ssrContextKey,
  sl as toDisplayString,
  Je as toHandlerKey,
  _e as toRaw,
  ol as toRef,
  nl as unref,
  ri as useSSRContext,
  Mi as useTemplateRef,
  hs as useTransitionState,
  bn as version,
  Yi as warn,
  Eo as watch,
  Ki as watchEffect,
  ds as withCtx,
  Ii as withDirectives
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_runtime-core@3.5.18/~/@vue/runtime-core/dist/runtime-core.esm-bundler.js
// module id = 0
// module chunks = 41